var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 53,
    viewBox: "0 0 72 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_160003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_61_160003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2257 1.00521L33.2232 1.00533C32.1346 1.05296 31.0348 1.16473 29.9439 1.30821L29.8788 0.813225L29.9439 1.30821C25.5793 1.8822 21.2905 3.09998 17.3816 5.10362C12.4774 7.6175 7.91973 11.7861 6.99547 17.2975C6.86309 18.0869 6.83548 18.8989 6.87126 19.7159C6.91516 20.7184 7.09722 21.7302 7.40837 22.6849C7.8554 24.0564 8.52108 25.3342 9.35578 26.5231L9.35579 26.5231C10.4582 28.0935 11.8814 29.4917 13.4278 30.6516C16.8756 33.2374 20.8989 34.9674 25.0919 36.0157C30.4958 37.3667 36.1481 37.6413 41.6736 36.9538C44.1659 36.6436 46.6347 36.0926 49.028 35.3278L49.028 35.3278C50.5009 34.8573 51.9634 34.3209 53.327 33.6392C55.8034 32.4009 58.218 30.9893 60.1456 29.0625C61.4893 27.7193 62.6732 26.2825 63.5092 24.6148C64.0815 23.4729 64.4865 22.2719 64.7043 21.0172L65.197 21.1027L64.7043 21.0171C65.5005 16.4323 63.2135 11.8635 59.742 8.81854L59.742 8.81849C58.703 7.90687 57.6256 7.06597 56.4678 6.33279L56.7353 5.91037L56.4678 6.33278C53.4431 4.41712 50.05 3.09076 46.5635 2.2191C44.8465 1.78987 43.1004 1.44947 41.3512 1.26208C39.8253 1.09864 38.3154 0.987179 36.7874 0.949768C36.3976 0.940235 36.0064 0.936337 35.614 0.936337C35.5173 0.936337 35.4406 0.933849 35.3747 0.931712C35.2623 0.928068 35.1814 0.925444 35.0863 0.937917L33.2257 1.00521ZM33.2257 1.00521L34.3537 0.950181C34.3541 0.950164 34.3545 0.950147 34.3549 0.95013M33.2257 1.00521L34.3549 0.95013M34.3549 0.95013C34.4267 0.947043 34.497 0.949037 34.5869 0.951588C34.6113 0.952278 34.6371 0.953009 34.6648 0.953692C34.7836 0.956626 34.9319 0.958205 35.0862 0.93793L34.3549 0.95013Z",
    stroke: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0848 3.2949C37.0786 3.30111 37.0931 3.30028 37.0938 3.29959C37.1 3.29339 37.0855 3.29421 37.0848 3.2949Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1536 3.2949C37.1474 3.30111 37.1619 3.30028 37.1626 3.29959C37.1688 3.29339 37.1543 3.29421 37.1536 3.2949Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8917 3.30858C36.8855 3.31478 36.9 3.31395 36.9006 3.31326C36.9068 3.30706 36.8924 3.30789 36.8917 3.30858Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9238 3.3042V3.31799H36.9652C36.948 3.30861 36.9438 3.30765 36.9238 3.3042Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4412 3.35917C35.9866 3.50338 35.5471 3.60747 35.1179 3.82682C34.8299 3.97393 34.5686 4.21147 34.2767 4.33803C34.2481 4.42972 34.0883 4.50485 34.0178 4.57075C33.8036 4.7708 33.5967 4.98201 33.4145 5.21239C32.9549 5.79433 32.5866 6.50945 32.4127 7.23274C31.9503 9.15496 32.4084 11.0174 32.9804 12.8583C33.2641 13.7713 33.5422 14.6864 33.8179 15.6018C33.9418 16.0134 34.0978 16.4237 34.194 16.8426C33.9696 16.8959 33.7468 17.0177 33.546 17.1278C32.686 17.6002 31.9348 18.4951 32.2304 19.531C32.2771 19.6943 32.3476 19.8562 32.4389 19.9998C32.9669 20.8308 33.9441 21.2927 34.8833 21.4805C35.1356 21.531 35.3974 21.5853 35.6554 21.5853C35.7057 21.926 35.8632 22.2753 35.9625 22.6055C36.1968 23.3831 36.4343 24.16 36.6752 24.9355C37.0739 26.2187 37.4783 27.5031 37.8416 28.7958C37.9645 29.2333 38.0493 29.6869 38.1877 30.1193C38.4165 30.835 38.5585 31.7859 38.2313 32.4906C38.1185 32.7334 37.9317 33.0505 37.6682 33.1524C37.6562 33.2451 37.3908 33.3238 37.3098 33.3549C36.9796 33.4819 36.5774 33.5594 36.2344 33.4291C36.1589 33.4007 36.0505 33.4117 36 33.3454C35.7777 33.3357 35.5118 33.1327 35.3343 33.0119C34.8545 32.6855 34.4378 32.2835 33.9458 31.9731C33.7537 31.8518 33.4659 31.6837 33.2289 31.7048C33.1879 31.6581 33.0943 31.677 33.0359 31.6772C32.8317 31.6775 32.6302 31.7554 32.4711 31.8826C32.0277 32.2373 31.9045 32.8978 32.0712 33.4143C32.2964 34.1123 32.9607 34.4973 33.6011 34.7473C33.7655 34.8114 33.9412 34.8649 34.1112 34.9104C34.1859 34.9302 34.27 34.9216 34.3318 34.9722C34.49 34.9636 34.6477 35.0132 34.8046 35.0251C35.1551 35.0518 35.5294 35.0462 35.876 34.9817C36.257 34.9109 36.6708 34.7952 37.0166 34.6169C37.2407 34.5012 37.4633 34.3525 37.6958 34.2553L37.682 34.2277C37.8719 34.1673 38.0391 33.9861 38.1921 33.8638C38.2475 33.8195 38.3303 33.7759 38.3438 33.7038C38.5265 33.6259 38.6306 33.4083 38.785 33.2902C38.8048 33.1789 38.9768 33.0312 39.0452 32.9376C39.2289 32.6862 39.3947 32.412 39.5308 32.1322C39.9465 31.2774 40.155 30.2389 40.1152 29.2862C40.0334 27.3233 39.3494 25.4602 38.7708 23.5981L38.3021 22.0678C38.224 21.8165 38.0815 21.5167 38.0681 21.2544C38.3221 21.2106 38.5964 21.0362 38.8125 20.9018C39.659 20.3748 40.3472 19.3851 39.8836 18.373C39.4924 17.5185 38.6083 17.0069 37.7372 16.752C37.4799 16.6768 37.2171 16.617 36.9513 16.5807C36.8655 16.569 36.6794 16.5817 36.6163 16.5178C36.5791 16.4797 36.5718 16.409 36.556 16.3601L36.4312 15.9603L36.008 14.5678C35.6922 13.4892 35.3545 12.4152 35.0208 11.3417C34.8547 10.8071 34.6727 10.272 34.54 9.72866C34.2805 8.66501 33.796 7.5631 33.9281 6.44741C33.9844 5.9719 34.2253 5.33854 34.7179 5.15145L34.7041 5.12388C34.8692 5.07259 35.0203 4.97402 35.1866 4.9219C35.4923 4.82595 35.8072 4.8458 36.1131 4.9197C36.2416 4.95086 36.4302 4.98298 36.5239 5.08252C36.7078 5.09038 36.9343 5.28449 37.0794 5.389C37.459 5.66239 37.809 5.97342 38.1883 6.24805C38.3469 6.36317 38.5964 6.55271 38.7987 6.5577C38.8551 6.64008 38.9864 6.60854 39.0607 6.668C39.2849 6.65352 39.4712 6.67041 39.6811 6.56908C39.8793 6.47326 40.0032 6.3021 40.1097 6.11887C40.5743 5.3202 40.1847 4.47783 39.4822 3.97627C38.9466 3.59396 38.1671 3.36179 37.5149 3.32154C37.256 3.30554 37.0023 3.30802 36.7445 3.33394C36.6616 3.34222 36.5139 3.39902 36.4412 3.35917Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1582 3.3042V3.31799H37.1996C37.1823 3.30861 37.1782 3.30765 37.1582 3.3042Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2225 3.30858C37.2163 3.31478 37.2308 3.31395 37.2315 3.31326C37.2377 3.30706 37.2232 3.30789 37.2225 3.30858Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2546 3.3042V3.31799H37.296C37.2788 3.30861 37.2746 3.30765 37.2546 3.3042Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3192 3.30858C37.313 3.31478 37.3274 3.31395 37.3281 3.31326C37.3343 3.30706 37.3199 3.30789 37.3192 3.30858Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3465 3.30858C37.3403 3.31478 37.3548 3.31395 37.3555 3.31326C37.3617 3.30706 37.3472 3.30789 37.3465 3.30858Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4569 3.30858C37.4507 3.31478 37.4651 3.31395 37.4658 3.31326C37.472 3.30706 37.4576 3.30789 37.4569 3.30858Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7952 3.32225C36.789 3.32845 36.8035 3.32762 36.8042 3.32694C36.8104 3.32073 36.7959 3.32156 36.7952 3.32225Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5672 3.32225C37.561 3.32845 37.5755 3.32762 37.5762 3.32694C37.5824 3.32073 37.5679 3.32156 37.5672 3.32225Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6573 3.33641C36.6511 3.34261 36.6656 3.34178 36.6663 3.3411C36.6725 3.33489 36.658 3.33572 36.6573 3.33641Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6085 3.33641C37.6023 3.34261 37.6167 3.34178 37.6174 3.3411C37.6236 3.33489 37.6092 3.33572 37.6085 3.33641Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.65 3.33641C37.6438 3.34261 37.6583 3.34178 37.6589 3.3411C37.6651 3.33489 37.6507 3.33572 37.65 3.33641Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4366 3.35008C36.4304 3.35628 36.4449 3.35546 36.4456 3.35477C36.4518 3.34856 36.4373 3.34939 36.4366 3.35008Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7188 3.35008C37.7126 3.35628 37.7271 3.35546 37.7278 3.35477C37.734 3.34856 37.7195 3.34939 37.7188 3.35008Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8887 3.35938V3.37316H37.9301C37.9128 3.36379 37.9087 3.36282 37.8887 3.35938Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3265 3.37742C36.3203 3.38363 36.3348 3.3828 36.3355 3.38211C36.3417 3.37591 36.3272 3.37673 36.3265 3.37742Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.285 3.39109C36.2788 3.3973 36.2933 3.39647 36.294 3.39578C36.3002 3.38958 36.2857 3.39041 36.285 3.39109Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9714 3.38672V3.40051H38.0266C38.0057 3.39113 37.9947 3.38906 37.9714 3.38672Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0772 3.40525C38.071 3.41146 38.0855 3.41063 38.0862 3.40994C38.0924 3.40374 38.0779 3.40457 38.0772 3.40525Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.137 3.41455V3.42834H38.1783C38.1611 3.41896 38.157 3.418 38.137 3.41455Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1965 3.42341C38.1958 3.4241 38.1951 3.43871 38.2013 3.43251C38.202 3.43182 38.2027 3.4172 38.1965 3.42341Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2291 3.4326C38.2229 3.4388 38.2374 3.43798 38.238 3.43729C38.2442 3.43108 38.2298 3.43191 38.2291 3.4326Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0369 3.46043C36.0307 3.46663 36.0452 3.46581 36.0459 3.46512C36.0521 3.45891 36.0376 3.45974 36.0369 3.46043Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2473 3.45557V3.46935H38.2887C38.2714 3.45998 38.2673 3.45901 38.2473 3.45557Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3162 3.46973V3.48351H38.3575C38.3403 3.47414 38.3362 3.47317 38.3162 3.46973Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8666 3.50641C35.866 3.5071 35.8653 3.52172 35.8715 3.51551C35.8722 3.51482 35.8729 3.50021 35.8666 3.50641Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.399 3.49707V3.51086H38.4403C38.4231 3.50148 38.4189 3.50052 38.399 3.49707Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4817 3.51074V3.52453H38.523C38.5058 3.51515 38.5017 3.51419 38.4817 3.51074Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7793 3.55199C35.801 3.54261 35.8038 3.54096 35.8207 3.52441C35.7989 3.53379 35.7962 3.53544 35.7793 3.55199Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5184 3.52928C38.5122 3.53548 38.5267 3.53466 38.5273 3.53397C38.5336 3.52776 38.5191 3.52859 38.5184 3.52928Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.546 3.54295C38.5398 3.54915 38.5542 3.54833 38.5549 3.54764C38.5611 3.54143 38.5467 3.54226 38.546 3.54295Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5645 3.53857V3.55236H38.6058C38.5886 3.54299 38.5844 3.54202 38.5645 3.53857Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6012 3.55662C38.5949 3.56283 38.6094 3.562 38.6101 3.56131C38.6163 3.55511 38.6018 3.55593 38.6012 3.55662Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7161 3.59375V3.60754H38.7574C38.7402 3.59802 38.7361 3.5972 38.7161 3.59375Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7667 3.62547C38.7605 3.63167 38.775 3.63085 38.7756 3.63016C38.7818 3.62395 38.7674 3.62478 38.7667 3.62547Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7895 3.63044C38.7888 3.63113 38.7881 3.64574 38.7943 3.63954C38.795 3.63885 38.7957 3.62423 38.7895 3.63044Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8218 3.63963C38.8156 3.64583 38.83 3.64501 38.8307 3.64432C38.8369 3.63811 38.8225 3.63894 38.8218 3.63963Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8401 3.64893V3.66271H38.8814C38.8642 3.65334 38.8601 3.65237 38.8401 3.64893Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8859 3.65778C38.8852 3.65847 38.8846 3.67308 38.8908 3.66688C38.8914 3.66619 38.8921 3.65158 38.8859 3.65778Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4072 3.6626V3.70396H35.421C35.4176 3.68397 35.4165 3.67983 35.4072 3.6626Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4303 3.66697C35.424 3.67318 35.4385 3.67235 35.4392 3.67166C35.4454 3.66546 35.4309 3.66628 35.4303 3.66697Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9548 3.68561C38.9541 3.6863 38.9534 3.70092 38.9596 3.69471C38.9603 3.69402 38.961 3.67941 38.9548 3.68561Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0375 3.72712C39.0369 3.72781 39.0362 3.74242 39.0424 3.73622C39.0431 3.73553 39.0437 3.72091 39.0375 3.72712Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1157 3.75879C39.1233 3.7814 39.1207 3.77878 39.1433 3.78636V3.75879H39.1157Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2767 3.84617C39.2705 3.85238 39.285 3.85155 39.2857 3.85086C39.2919 3.84466 39.2774 3.84548 39.2767 3.84617Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3319 3.874C39.3257 3.88021 39.3401 3.87938 39.3408 3.87869C39.347 3.87249 39.3326 3.87332 39.3319 3.874Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9567 3.90632C34.956 3.90701 34.9554 3.92163 34.9616 3.91542C34.9622 3.91473 34.9629 3.90012 34.9567 3.90632Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.387 3.91502C39.3808 3.92122 39.3953 3.9204 39.396 3.91971C39.4022 3.9135 39.3877 3.91433 39.387 3.91502Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4511 3.94733C39.4504 3.94802 39.4497 3.96263 39.4559 3.95643C39.4566 3.95574 39.4573 3.94113 39.4511 3.94733Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8188 3.97516C34.8181 3.97585 34.8174 3.99047 34.8236 3.98426C34.8243 3.98357 34.825 3.96896 34.8188 3.97516Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5063 3.98884C39.5056 3.98952 39.5049 4.00414 39.5111 3.99793C39.5118 3.99725 39.5125 3.98263 39.5063 3.98884Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7271 4.02537C34.7209 4.03158 34.7354 4.03075 34.7361 4.03006C34.7423 4.02386 34.7278 4.02468 34.7271 4.02537Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5615 4.03034C39.5608 4.03103 39.5601 4.04564 39.5663 4.03944C39.567 4.03875 39.5677 4.02414 39.5615 4.03034Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5801 4.1173V4.13109H34.6214C34.6042 4.12158 34.6001 4.12075 34.5801 4.1173Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7042 4.1494C39.698 4.1556 39.7125 4.15477 39.7131 4.15408C39.7193 4.14788 39.7049 4.14871 39.7042 4.1494Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7594 4.1909C39.7532 4.1971 39.7676 4.19628 39.7683 4.19559C39.7745 4.18938 39.76 4.19021 39.7594 4.1909Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8006 4.2324C39.7944 4.23861 39.8089 4.23778 39.8096 4.23709C39.8158 4.23089 39.8013 4.23171 39.8006 4.2324Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3824 4.25975C34.3762 4.26595 34.3907 4.26512 34.3914 4.26443C34.3976 4.25823 34.3831 4.25906 34.3824 4.25975Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8371 4.26471C39.8364 4.2654 39.8357 4.28002 39.8419 4.27381C39.8426 4.27312 39.8433 4.25851 39.8371 4.26471Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8786 4.30573C39.8779 4.30642 39.8772 4.32103 39.8834 4.31483C39.8841 4.31414 39.8848 4.29953 39.8786 4.30573Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9475 4.38874C39.9468 4.38943 39.9461 4.40404 39.9523 4.39784C39.953 4.39715 39.9537 4.38253 39.9475 4.38874Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2121 4.40241C34.2114 4.4031 34.2107 4.41771 34.2169 4.41151C34.2176 4.41082 34.2183 4.39621 34.2121 4.40241Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9798 4.43895C39.9736 4.44515 39.9881 4.44432 39.9888 4.44363C39.995 4.43743 39.9805 4.43826 39.9798 4.43895Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1433 4.45759C34.1426 4.45827 34.1419 4.47289 34.1481 4.46668C34.1488 4.466 34.1495 4.45138 34.1433 4.45759Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1296 4.47126C34.1289 4.47195 34.1282 4.48656 34.1344 4.48036C34.1351 4.47967 34.1358 4.46505 34.1296 4.47126Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0929 4.49441C34.0866 4.50061 34.1011 4.49979 34.1018 4.4991C34.108 4.49289 34.0935 4.49372 34.0929 4.49441Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0286 4.53088V4.54466H34.0699C34.0527 4.53529 34.0486 4.53432 34.0286 4.53088Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0672 4.54492V4.58628H40.081C40.0775 4.56629 40.0765 4.56216 40.0672 4.54492ZM34.0103 4.56326C34.0041 4.56946 34.0186 4.56864 34.0193 4.56795C34.0255 4.56174 34.011 4.56257 34.0103 4.56326Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1267 4.65046C40.126 4.65115 40.1253 4.66576 40.1315 4.65956C40.1322 4.65887 40.1329 4.64425 40.1267 4.65046Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8907 4.66906L33.877 4.69663H33.9045C33.9045 4.67113 33.9087 4.67802 33.8907 4.66906Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8448 4.7285C33.8386 4.7347 33.8531 4.73387 33.8538 4.73318C33.86 4.72698 33.8455 4.72781 33.8448 4.7285Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.739 4.80664V4.848H33.7528C33.7494 4.82801 33.7483 4.82387 33.739 4.80664Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2094 4.82966C40.2087 4.83035 40.208 4.84496 40.2142 4.83876C40.2149 4.83807 40.2156 4.82345 40.2094 4.82966Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5725 4.84814V4.87572C35.5951 4.86827 35.5927 4.87062 35.6001 4.84814H35.5725Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6277 4.84814C35.6353 4.87075 35.6327 4.86813 35.6553 4.87572C35.6477 4.85311 35.6503 4.85573 35.6277 4.84814Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4303 4.86668C35.424 4.87288 35.4385 4.87206 35.4392 4.87137C35.4454 4.86516 35.4309 4.86599 35.4303 4.86668Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6785 4.86668C35.6723 4.87288 35.6868 4.87206 35.6875 4.87137C35.6937 4.86516 35.6792 4.86599 35.6785 4.86668Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7335 4.86668C35.7273 4.87288 35.7417 4.87206 35.7424 4.87137C35.7486 4.86516 35.7342 4.86599 35.7335 4.86668Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7611 4.86668C35.7549 4.87288 35.7693 4.87206 35.77 4.87137C35.7762 4.86516 35.7618 4.86599 35.7611 4.86668Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7887 4.86668C35.7824 4.87288 35.7969 4.87206 35.7976 4.87137C35.8038 4.86516 35.7893 4.86599 35.7887 4.86668Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8208 4.86182V4.8756H35.8622C35.8449 4.86623 35.8408 4.86526 35.8208 4.86182Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3614 4.88035C35.3552 4.88656 35.3697 4.88573 35.3704 4.88504C35.3766 4.87884 35.3621 4.87966 35.3614 4.88035Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8577 4.88035C35.8515 4.88656 35.866 4.88573 35.8667 4.88504C35.8729 4.87884 35.8584 4.87966 35.8577 4.88035Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8896 4.87598V4.88976H35.9862C35.9541 4.87625 35.9246 4.87625 35.8896 4.87598Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0046 4.88483C36.0039 4.88552 36.0032 4.90014 36.0094 4.89393C36.0101 4.89324 36.0108 4.87863 36.0046 4.88483Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6793 4.89431C33.6731 4.90052 33.6875 4.89969 33.6882 4.899C33.6944 4.8928 33.68 4.89362 33.6793 4.89431Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2235 4.9077C35.2173 4.9139 35.2317 4.91307 35.2324 4.91238C35.2386 4.90618 35.2242 4.90701 35.2235 4.9077Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2647 4.9077C35.2585 4.9139 35.273 4.91307 35.2737 4.91238C35.2799 4.90618 35.2654 4.90701 35.2647 4.9077Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0506 4.9077C36.0444 4.9139 36.0589 4.91307 36.0596 4.91238C36.0658 4.90618 36.0513 4.90701 36.0506 4.9077Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1058 4.92186C36.0996 4.92806 36.1141 4.92723 36.1148 4.92654C36.121 4.92034 36.1065 4.92117 36.1058 4.92186Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.638 4.93533C33.6318 4.94153 33.6463 4.94071 33.647 4.94002C33.6532 4.93381 33.6387 4.93464 33.638 4.93533Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1379 4.93066V4.94445H36.1793C36.1621 4.93508 36.1579 4.93411 36.1379 4.93066Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0947 4.95368C35.094 4.95437 35.0933 4.96898 35.0995 4.96278C35.1002 4.96209 35.1009 4.94748 35.0947 4.95368Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2161 4.9492C36.2099 4.9554 36.2244 4.95458 36.2251 4.95389C36.2313 4.94768 36.2168 4.94851 36.2161 4.9492Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2526 4.95368C36.2519 4.95437 36.2513 4.96898 36.2575 4.96278C36.2581 4.96209 36.2588 4.94748 36.2526 4.95368Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6012 4.97217L33.5874 4.99974C33.6048 4.98637 33.6065 4.99023 33.6012 4.97217Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3078 4.98151C36.3071 4.9822 36.3064 4.99681 36.3126 4.99061C36.3133 4.98992 36.314 4.97531 36.3078 4.98151Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5009 5.05036C36.5002 5.05105 36.4995 5.06566 36.5058 5.05946C36.5064 5.05877 36.5071 5.04415 36.5009 5.05036Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8188 5.07819C34.8181 5.07888 34.8174 5.09349 34.8236 5.08729C34.8243 5.0866 34.825 5.07199 34.8188 5.07819Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5609 5.0869C36.5547 5.0931 36.5691 5.09227 36.5698 5.09158C36.576 5.08538 36.5616 5.08621 36.5609 5.0869Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5791 5.09619V5.10998H36.6205C36.6032 5.1006 36.5991 5.09964 36.5791 5.09619Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6525 5.11921C36.6518 5.1199 36.6512 5.13451 36.6574 5.12831C36.658 5.12762 36.6587 5.113 36.6525 5.11921Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7124 5.15623C36.7062 5.16244 36.7207 5.16161 36.7214 5.16092C36.7276 5.15471 36.7131 5.15554 36.7124 5.15623ZM33.4401 5.17471C33.4394 5.17539 33.4388 5.19001 33.445 5.1838C33.4456 5.18312 33.4463 5.1685 33.4401 5.17471Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.612 5.20221C34.6113 5.2029 34.6106 5.21752 34.6168 5.21131C34.6175 5.21062 34.6182 5.19601 34.612 5.20221Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7677 5.19725C36.7615 5.20345 36.7759 5.20262 36.7766 5.20194C36.7828 5.19573 36.7684 5.19656 36.7677 5.19725ZM33.3989 5.21572C33.3982 5.21641 33.3975 5.23103 33.4037 5.22482C33.4044 5.22413 33.4051 5.20952 33.3989 5.21572Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8228 5.22508C36.8166 5.23128 36.8311 5.23046 36.8318 5.22977C36.838 5.22356 36.8235 5.22439 36.8228 5.22508Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3713 5.25728C33.3706 5.25797 33.3699 5.27259 33.3761 5.26638C33.3768 5.26569 33.3775 5.25108 33.3713 5.25728Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3153 5.26172V5.30308H40.3291C40.3257 5.28309 40.3246 5.27895 40.3153 5.26172Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9697 5.31257C36.969 5.31326 36.9683 5.32787 36.9745 5.32167C36.9752 5.32098 36.9759 5.30636 36.9697 5.31257Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3298 5.32624C33.3291 5.32693 33.3284 5.34154 33.3346 5.33534C33.3353 5.33465 33.336 5.32003 33.3298 5.32624Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3161 5.33991C33.3154 5.3406 33.3147 5.35521 33.3209 5.34901C33.3216 5.34832 33.3223 5.33371 33.3161 5.33991Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2796 5.37662C33.2734 5.38282 33.2879 5.382 33.2886 5.38131C33.2948 5.3751 33.2803 5.37593 33.2796 5.37662Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3334 5.38141C40.3328 5.3821 40.3321 5.39672 40.3383 5.39051C40.339 5.38982 40.3396 5.37521 40.3334 5.38141Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2746 5.39509C33.2739 5.39577 33.2732 5.41039 33.2794 5.40418C33.2801 5.40349 33.2808 5.38888 33.2746 5.39509Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.373 5.38574V5.4271H34.3868C34.3834 5.40711 34.3825 5.40298 34.373 5.38574Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0709 5.39061C37.0647 5.39681 37.0792 5.39598 37.0798 5.39529C37.086 5.38909 37.0716 5.38992 37.0709 5.39061Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1213 5.42243C37.1206 5.42312 37.1199 5.43773 37.1261 5.43153C37.1268 5.43084 37.1275 5.41623 37.1213 5.42243Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3334 5.45026C40.3328 5.45095 40.3321 5.46556 40.3383 5.45936C40.339 5.45867 40.3396 5.44406 40.3334 5.45026Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1812 5.45945C37.175 5.46566 37.1895 5.46483 37.1902 5.46414C37.1964 5.45794 37.1819 5.45876 37.1812 5.45945Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2089 5.4733C37.2027 5.4795 37.2171 5.47868 37.2178 5.47799C37.224 5.47178 37.2095 5.47261 37.2089 5.4733Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2058 5.49177C33.2051 5.49245 33.2044 5.50707 33.2106 5.50086C33.2113 5.50018 33.212 5.48556 33.2058 5.49177Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3334 5.49177C40.3328 5.49245 40.3321 5.50707 40.3383 5.50086C40.339 5.50018 40.3396 5.48556 40.3334 5.49177Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2315 5.50533C37.2308 5.50602 37.2301 5.52063 37.2363 5.51443C37.237 5.51374 37.2377 5.49913 37.2315 5.50533Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3198 5.50544C40.3191 5.50613 40.3184 5.52074 40.3246 5.51454C40.3253 5.51385 40.326 5.49923 40.3198 5.50544Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.286 5.51463C34.2798 5.52083 34.2942 5.52001 34.2949 5.51932C34.3011 5.51311 34.2867 5.51394 34.286 5.51463Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3198 5.53278C40.3191 5.53347 40.3184 5.54808 40.3246 5.54188C40.3253 5.54119 40.326 5.52658 40.3198 5.53278Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2866 5.54694C37.2859 5.54763 37.2852 5.56224 37.2914 5.55604C37.2921 5.55535 37.2928 5.54074 37.2866 5.54694Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3015 5.5791V5.62046H40.3153C40.3119 5.60047 40.311 5.59634 40.3015 5.5791Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.123 5.61579C33.1223 5.61648 33.1216 5.63109 33.1278 5.62489C33.1285 5.6242 33.1292 5.60958 33.123 5.61579Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3832 5.62946C37.3826 5.63015 37.3819 5.64476 37.3881 5.63856C37.3888 5.63787 37.3895 5.62326 37.3832 5.62946Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0954 5.64313C33.0947 5.64382 33.094 5.65844 33.1002 5.65223C33.1009 5.65154 33.1016 5.63693 33.0954 5.64313Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3059 5.64313C40.3052 5.64382 40.3045 5.65844 40.3107 5.65223C40.3114 5.65154 40.3121 5.63693 40.3059 5.64313Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4338 5.64795V5.68931H37.4476C37.4442 5.66932 37.4433 5.66518 37.4338 5.64795Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2922 5.67096C40.2915 5.67165 40.2908 5.68627 40.297 5.68006C40.2977 5.67937 40.2984 5.66476 40.2922 5.67096Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0865 5.68016C33.0803 5.68636 33.0948 5.68553 33.0955 5.68485C33.1017 5.67864 33.0872 5.67947 33.0865 5.68016Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1572 5.69831C34.1565 5.699 34.1558 5.71361 34.162 5.70741C34.1627 5.70672 34.1634 5.6921 34.1572 5.69831Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0452 5.73484C33.039 5.74105 33.0535 5.74022 33.0542 5.73953C33.0604 5.73333 33.0459 5.73416 33.0452 5.73484Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.512 5.73484C37.5058 5.74105 37.5203 5.74022 37.521 5.73953C37.5272 5.73333 37.5127 5.73416 37.512 5.73484Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1296 5.75348C34.1289 5.75417 34.1282 5.76879 34.1344 5.76258C34.1351 5.76189 34.1358 5.74728 34.1296 5.75348Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2645 5.75338C40.2638 5.75407 40.2632 5.76868 40.2694 5.76248C40.27 5.76179 40.2707 5.74717 40.2645 5.75338Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5579 5.77197V5.78576H37.5992C37.582 5.77639 37.5778 5.77542 37.5579 5.77197ZM33.0037 5.79031C32.9975 5.79651 33.012 5.79569 33.0127 5.795C33.0189 5.78879 33.0044 5.78962 33.0037 5.79031Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2557 5.79002C40.2495 5.79622 40.264 5.7954 40.2647 5.79471C40.2709 5.7885 40.2564 5.78933 40.2557 5.79002Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6224 5.81803C37.6162 5.82423 37.6307 5.8234 37.6314 5.82271C37.6376 5.81651 37.6231 5.81734 37.6224 5.81803Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9807 5.82715V5.86851H32.9945C32.9911 5.84852 32.99 5.84438 32.9807 5.82715Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6361 5.83152C37.6299 5.83773 37.6443 5.8369 37.645 5.83621C37.6512 5.83001 37.6368 5.83084 37.6361 5.83152Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0881 5.85006C34.0874 5.85075 34.0867 5.86536 34.0929 5.85916C34.0936 5.85847 34.0943 5.84385 34.0881 5.85006Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6637 5.85936C37.6574 5.86556 37.6719 5.86473 37.6726 5.86404C37.6788 5.85784 37.6643 5.85867 37.6637 5.85936Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6819 5.86816C37.6895 5.89077 37.6869 5.88829 37.7094 5.89574C37.702 5.87326 37.7043 5.87561 37.6819 5.86816Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2232 5.87751C40.2225 5.8782 40.2219 5.89281 40.2281 5.88661C40.2287 5.88592 40.2294 5.8713 40.2232 5.87751Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9438 5.90534C32.9431 5.90603 32.9424 5.92064 32.9486 5.91444C32.9493 5.91375 32.95 5.89914 32.9438 5.90534Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0605 5.90534C34.0598 5.90603 34.0591 5.92064 34.0653 5.91444C34.066 5.91375 34.0667 5.89914 34.0605 5.90534Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7188 5.90037C37.7126 5.90658 37.7271 5.90575 37.7278 5.90506C37.734 5.89886 37.7195 5.89968 37.7188 5.90037Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7692 5.94635C37.7685 5.94704 37.7679 5.96166 37.7741 5.95545C37.7747 5.95476 37.7754 5.94015 37.7692 5.94635Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1957 5.94635C40.1951 5.94704 40.1944 5.96166 40.2006 5.95545C40.2013 5.95476 40.202 5.94015 40.1957 5.94635Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0329 5.98786C34.0322 5.98855 34.0315 6.00316 34.0377 5.99696C34.0384 5.99627 34.0391 5.98165 34.0329 5.98786Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1818 5.98786C40.1811 5.98855 40.1805 6.00316 40.1867 5.99696C40.1873 5.99627 40.188 5.98165 40.1818 5.98786Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8934 5.99705C32.8872 6.00326 32.9017 6.00243 32.9023 6.00174C32.9086 5.99553 32.8941 5.99636 32.8934 5.99705Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.024 6.01072C34.0178 6.01693 34.0323 6.0161 34.033 6.01541C34.0392 6.00921 34.0247 6.01003 34.024 6.01072Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8886 6.02936C32.8879 6.03005 32.8872 6.04467 32.8934 6.03846C32.8941 6.03777 32.8948 6.02316 32.8886 6.02936Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.159 6.03856C40.1528 6.04476 40.1673 6.04393 40.168 6.04324C40.1742 6.03704 40.1597 6.03787 40.159 6.03856Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8567 6.04785V6.07543C32.8791 6.06798 32.8767 6.07046 32.8843 6.04785H32.8567Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.976 6.09821C37.9753 6.0989 37.9746 6.11351 37.9808 6.10731C37.9815 6.10662 37.9822 6.09201 37.976 6.09821Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8334 6.11188C32.8328 6.11257 32.8321 6.12719 32.8383 6.12098C32.839 6.12029 32.8396 6.10568 32.8334 6.11188Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0312 6.13971C38.0305 6.1404 38.0298 6.15502 38.036 6.14881C38.0367 6.14812 38.0374 6.13351 38.0312 6.13971Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0854 6.15339C40.0847 6.15408 40.084 6.16869 40.0902 6.16248C40.0909 6.1618 40.0916 6.14718 40.0854 6.15339Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9641 6.20846C33.9634 6.20914 33.9627 6.22376 33.9689 6.21755C33.9696 6.21687 33.9703 6.20225 33.9641 6.20846Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1415 6.22223C38.1409 6.22292 38.1402 6.23754 38.1464 6.23133C38.1471 6.23064 38.1478 6.21603 38.1415 6.22223Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0439 6.23591C40.0432 6.2366 40.0425 6.25121 40.0487 6.24501C40.0494 6.24432 40.0501 6.2297 40.0439 6.23591Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1966 6.25007C38.1959 6.25076 38.1952 6.26537 38.2014 6.25917C38.2021 6.25848 38.2028 6.24386 38.1966 6.25007ZM32.7646 6.26385C32.7639 6.26454 32.7632 6.27916 32.7694 6.27295C32.7701 6.27226 32.7708 6.25765 32.7646 6.26385Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9458 6.25439V6.29576H33.9596C33.9561 6.27576 33.9553 6.27163 33.9458 6.25439Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.238 6.29108C38.2373 6.29177 38.2366 6.30638 38.2428 6.30018C38.2435 6.29949 38.2442 6.28488 38.238 6.29108Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9501 6.30524C33.9495 6.30593 33.9488 6.32055 33.955 6.31434C33.9557 6.31365 33.9563 6.29904 33.9501 6.30524Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9614 6.33259C39.9607 6.33327 39.96 6.34789 39.9662 6.34168C39.9669 6.341 39.9676 6.32638 39.9614 6.33259Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9365 6.34626C33.9358 6.34695 33.9351 6.36156 33.9413 6.35536C33.942 6.35467 33.9427 6.34005 33.9365 6.34626Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3255 6.34178C38.3193 6.34798 38.3338 6.34715 38.3345 6.34647C38.3407 6.34026 38.3262 6.34109 38.3255 6.34178Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7142 6.35545C32.708 6.36165 32.7225 6.36083 32.7232 6.36014C32.7294 6.35393 32.7149 6.35476 32.7142 6.35545Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9319 6.37842V6.41978H33.9457C33.9422 6.39979 33.9412 6.39565 33.9319 6.37842Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6912 6.39209V6.43345H32.7049C32.7015 6.41346 32.7005 6.40932 32.6912 6.39209Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9246 6.39695C39.9184 6.40316 39.9329 6.40233 39.9336 6.40164C39.9398 6.39544 39.9253 6.39627 39.9246 6.39695Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4448 6.4151C38.4441 6.41579 38.4434 6.43041 38.4496 6.4242C38.4503 6.42352 38.451 6.4089 38.4448 6.4151Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9365 6.44295C33.9358 6.44364 33.9351 6.45811 33.9413 6.45191C33.942 6.45122 33.9427 6.43674 33.9365 6.44295Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4999 6.44295C38.4993 6.44364 38.4986 6.45811 38.5048 6.45191C38.5055 6.45122 38.5062 6.43674 38.4999 6.44295Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5093 6.44727V6.46105H38.5506C38.5334 6.45157 38.5293 6.45071 38.5093 6.44727Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8421 6.46577C39.8359 6.47197 39.8504 6.47128 39.8511 6.47059C39.8573 6.46439 39.8428 6.46508 39.8421 6.46577Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9228 6.4844C33.9221 6.48509 33.9214 6.49957 33.9276 6.49337C33.9283 6.49268 33.929 6.4782 33.9228 6.4844Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9365 6.49812C33.9358 6.49881 33.9351 6.51329 33.9413 6.50709C33.942 6.5064 33.9427 6.49192 33.9365 6.49812Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6453 6.50727C32.6391 6.51348 32.6536 6.51279 32.6543 6.5121C32.6605 6.50589 32.646 6.50658 32.6453 6.50727Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9182 6.50244V6.5438H33.932C33.9286 6.52381 33.9275 6.51967 33.9182 6.50244Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6151 6.50727C38.6089 6.51348 38.6233 6.51279 38.624 6.5121C38.6302 6.50589 38.6158 6.50658 38.6151 6.50727Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6516 6.52547C38.6509 6.52616 38.6502 6.54063 38.6564 6.53443C38.6571 6.53374 38.6578 6.51926 38.6516 6.52547Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7115 6.54829C38.7053 6.55449 38.7198 6.5538 38.7205 6.55311C38.7267 6.54691 38.7122 6.5476 38.7115 6.54829Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.748 6.5533C38.7473 6.55399 38.7466 6.56847 38.7528 6.56226C38.7535 6.56157 38.7542 6.5471 38.748 6.5533Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6766 6.57612C39.6704 6.58232 39.6849 6.58163 39.6856 6.58094C39.6918 6.57474 39.6773 6.57543 39.6766 6.57612Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8079 6.58979C38.8017 6.596 38.8162 6.59531 38.8169 6.59462C38.8231 6.58841 38.8086 6.5891 38.8079 6.58979ZM39.6214 6.58979C39.6152 6.596 39.6296 6.59531 39.6303 6.59462C39.6365 6.58841 39.622 6.5891 39.6214 6.58979Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9089 6.60848C33.9082 6.60916 33.9075 6.62364 33.9137 6.61744C33.9144 6.61675 33.9151 6.60227 33.9089 6.60848Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8262 6.59912V6.61291H38.8675C38.8503 6.6036 38.8462 6.60257 38.8262 6.59912Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.613 6.62215C32.6123 6.62284 32.6116 6.63731 32.6178 6.63111C32.6185 6.63042 32.6192 6.61594 32.613 6.62215Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9089 6.61279V6.62658L38.9503 6.64037C38.9369 6.61589 38.9377 6.61848 38.9089 6.61279Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9089 6.63582C33.9082 6.63651 33.9075 6.65098 33.9137 6.64478C33.9144 6.64409 33.9151 6.62962 33.9089 6.63582Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9917 6.64062V6.65441H39.0331C39.0158 6.64511 39.0117 6.64407 38.9917 6.64062Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0332 6.64062C39.0408 6.6632 39.0382 6.66062 39.0608 6.6682C39.0534 6.64579 39.0558 6.64821 39.0332 6.64062Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4559 6.64497C39.4497 6.65117 39.4642 6.65048 39.4648 6.64979C39.4711 6.64359 39.4566 6.64428 39.4559 6.64497Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5854 6.66365C32.5847 6.66434 32.584 6.67882 32.5902 6.67261C32.5909 6.67192 32.5916 6.65745 32.5854 6.66365Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4698 6.65864C39.4636 6.66484 39.4781 6.66415 39.4788 6.66346C39.485 6.65726 39.4705 6.65795 39.4698 6.65864Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0881 6.66797V6.68176H39.1295C39.1123 6.67245 39.1081 6.67142 39.0881 6.66797Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1527 6.67231C39.1465 6.67851 39.1609 6.67783 39.1616 6.67714C39.1678 6.67093 39.1534 6.67162 39.1527 6.67231Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1848 6.66797V6.68176H39.2262C39.2089 6.67245 39.2048 6.67142 39.1848 6.66797Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2767 6.67231C39.2705 6.67851 39.285 6.67783 39.2857 6.67714C39.2919 6.67093 39.2774 6.67162 39.2767 6.67231Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3319 6.67231C39.3257 6.67851 39.3401 6.67783 39.3408 6.67714C39.347 6.67093 39.3326 6.67162 39.3319 6.67231Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5765 6.70014C32.5703 6.70635 32.5848 6.70566 32.5855 6.70497C32.5917 6.69876 32.5772 6.69945 32.5765 6.70014Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9089 6.71883C33.9082 6.71952 33.9075 6.73399 33.9137 6.72779C33.9144 6.7271 33.9151 6.71262 33.9089 6.71883Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5489 6.79682C32.5427 6.80303 32.5572 6.80234 32.5579 6.80165C32.5641 6.79544 32.5496 6.79613 32.5489 6.79682Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9088 6.82913C33.9081 6.82982 33.9074 6.8443 33.9136 6.83809C33.9143 6.8374 33.915 6.82293 33.9088 6.82913Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5118 6.86084L32.498 6.9022C32.5225 6.88876 32.5251 6.88531 32.5118 6.86084Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9043 6.86084V6.94356H33.9181C33.9174 6.91254 33.9164 6.8891 33.9043 6.86084Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9089 6.98055C33.9082 6.98124 33.9075 6.99571 33.9137 6.98951C33.9144 6.98882 33.9151 6.97434 33.9089 6.98055Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4475 7.06351C32.4468 7.0642 32.4461 7.07867 32.4523 7.07247C32.453 7.07178 32.4537 7.0573 32.4475 7.06351Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9228 7.06355C33.9221 7.06424 33.9214 7.07872 33.9276 7.07252C33.9283 7.07183 33.929 7.05735 33.9228 7.06355Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.411 7.19638C32.4048 7.20258 32.4192 7.20189 32.4199 7.2012C32.4261 7.195 32.4117 7.19569 32.411 7.19638Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9365 7.28377C33.9358 7.28446 33.9351 7.29893 33.9413 7.29273C33.942 7.29204 33.9427 7.27756 33.9365 7.28377Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3786 7.33894C32.3779 7.33963 32.3772 7.35411 32.3834 7.34791C32.3841 7.34722 32.3848 7.33274 32.3786 7.33894Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3647 7.4493C32.364 7.44999 32.3633 7.46446 32.3695 7.45826C32.3702 7.45757 32.3709 7.44309 32.3647 7.4493Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3647 7.47713C32.364 7.47782 32.3633 7.49229 32.3695 7.48609C32.3702 7.4854 32.3709 7.47092 32.3647 7.47713Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.351 7.4908C32.3503 7.49149 32.3496 7.50597 32.3558 7.49976C32.3565 7.49907 32.3572 7.4846 32.351 7.4908Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9916 7.5323C33.991 7.53299 33.9903 7.54747 33.9965 7.54127C33.9972 7.54058 33.9979 7.5261 33.9916 7.5323Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3371 7.54598C32.3364 7.54666 32.3357 7.56114 32.3419 7.55494C32.3426 7.55425 32.3433 7.53977 32.3371 7.54598Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9777 7.54598C33.977 7.54666 33.9764 7.56114 33.9826 7.55494C33.9832 7.55425 33.9839 7.53977 33.9777 7.54598Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3188 7.61914V7.6605H32.3326C32.3292 7.64051 32.3282 7.63637 32.3188 7.61914Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0192 7.67C34.0185 7.67069 34.0179 7.68516 34.0241 7.67896C34.0247 7.67827 34.0254 7.66379 34.0192 7.67Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3095 7.69734C32.3088 7.69803 32.3081 7.71251 32.3143 7.7063C32.315 7.70562 32.3157 7.69114 32.3095 7.69734ZM34.0053 7.69734C34.0046 7.69803 34.0039 7.71251 34.0101 7.7063C34.0108 7.70562 34.0115 7.69114 34.0053 7.69734Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2958 7.76668C32.2952 7.76737 32.2945 7.78184 32.3007 7.77564C32.3014 7.77495 32.3021 7.76047 32.2958 7.76668Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2958 7.79402C32.2952 7.79471 32.2945 7.80919 32.3007 7.80298C32.3014 7.80229 32.3021 7.78782 32.2958 7.79402Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0468 7.83553C34.0461 7.83622 34.0454 7.85069 34.0516 7.84449C34.0523 7.8438 34.053 7.82932 34.0468 7.83553Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2683 7.91811C32.2676 7.9188 32.2669 7.93328 32.2731 7.92707C32.2738 7.92638 32.2745 7.91191 32.2683 7.91811Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2637 7.96387V8.00523H32.2775C32.274 7.98523 32.2732 7.9811 32.2637 7.96387Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2594 8.02339C32.2532 8.02959 32.2676 8.0289 32.2683 8.02821C32.2745 8.02201 32.26 8.0227 32.2594 8.02339Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2546 8.11098C32.2539 8.11167 32.2532 8.12615 32.2594 8.11994C32.2601 8.11926 32.2608 8.10478 32.2546 8.11098Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1157 8.15242C34.115 8.15311 34.1143 8.16759 34.1205 8.16138C34.1212 8.16069 34.1219 8.14622 34.1157 8.15242Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2407 8.18025C32.24 8.18094 32.2393 8.19542 32.2455 8.18921C32.2462 8.18853 32.2469 8.17405 32.2407 8.18025Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2407 8.22133C32.24 8.22202 32.2393 8.2365 32.2455 8.2303C32.2462 8.22961 32.2469 8.21513 32.2407 8.22133Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2407 8.2491C32.24 8.24979 32.2393 8.26427 32.2455 8.25806C32.2462 8.25737 32.2469 8.2429 32.2407 8.2491Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.227 8.26277C32.2263 8.26346 32.2256 8.27794 32.2318 8.27173C32.2325 8.27104 32.2332 8.25657 32.227 8.26277Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2224 8.29492V8.33628H32.2362C32.2328 8.31629 32.2317 8.31216 32.2224 8.29492Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2224 8.3501V8.39146H32.2362C32.2328 8.37147 32.2317 8.36733 32.2224 8.3501Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.227 8.41463C32.2263 8.41532 32.2256 8.42979 32.2318 8.42359C32.2325 8.4229 32.2332 8.40842 32.227 8.41463Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1938 8.46045V8.50181H34.2076C34.2042 8.48182 34.2033 8.47768 34.1938 8.46045Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2087 8.48779V8.52915H32.2225C32.2191 8.50916 32.218 8.50503 32.2087 8.48779Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2087 8.54297V8.62569H32.2225C32.2218 8.59467 32.2208 8.57123 32.2087 8.54297Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.226 8.6075C34.2253 8.60819 34.2246 8.62266 34.2308 8.61646C34.2315 8.61577 34.2322 8.60129 34.226 8.6075Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1948 8.63965C32.2024 8.66222 32.2 8.65981 32.2224 8.66722V8.63965H32.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 8.67635C32.2124 8.67704 32.2117 8.69151 32.2179 8.68531C32.2186 8.68462 32.2193 8.67014 32.2131 8.67635Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1994 8.69002C32.1987 8.69071 32.198 8.70518 32.2042 8.69898C32.2049 8.69829 32.2056 8.68381 32.1994 8.69002Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1994 8.73152C32.1987 8.73221 32.198 8.74669 32.2042 8.74048C32.2049 8.73979 32.2056 8.72532 32.1994 8.73152Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 8.77303C32.2124 8.77372 32.2117 8.78819 32.2179 8.78199C32.2186 8.7813 32.2193 8.76682 32.2131 8.77303Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3088 8.92435C34.3081 8.92504 34.3074 8.93951 34.3136 8.93331C34.3143 8.93262 34.315 8.91814 34.3088 8.92435Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1994 8.9659C32.1987 8.96659 32.198 8.98106 32.2042 8.97486C32.2049 8.97417 32.2056 8.95969 32.1994 8.9659Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1994 9.0074C32.1987 9.00809 32.198 9.02257 32.2042 9.01636C32.2049 9.01567 32.2056 9.0012 32.1994 9.0074Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3915 9.20027C34.3909 9.20096 34.3902 9.21544 34.3964 9.20923C34.3971 9.20854 34.3978 9.19407 34.3915 9.20027Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1948 9.20459C32.2024 9.22717 32.2 9.22475 32.2224 9.23216V9.20459H32.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 9.26912C32.2124 9.26981 32.2117 9.28429 32.2179 9.27808C32.2186 9.27739 32.2193 9.26292 32.2131 9.26912Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 9.3243C32.2124 9.32499 32.2117 9.33946 32.2179 9.33326C32.2186 9.33257 32.2193 9.31809 32.2131 9.3243Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2087 9.38379V9.41136C32.2311 9.40395 32.2287 9.40636 32.2363 9.38379H32.2087Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 9.43465C32.2124 9.43534 32.2117 9.44981 32.2179 9.44361C32.2186 9.44292 32.2193 9.42844 32.2131 9.43465Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.227 9.47622C32.2263 9.47691 32.2256 9.49139 32.2318 9.48518C32.2325 9.48449 32.2332 9.47002 32.227 9.47622Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2131 9.48982C32.2124 9.49051 32.2117 9.50499 32.2179 9.49878C32.2186 9.4981 32.2193 9.48362 32.2131 9.48982Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.227 9.53133C32.2263 9.53202 32.2256 9.54649 32.2318 9.54029C32.2325 9.5396 32.2332 9.52512 32.227 9.53133Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.227 9.60017C32.2263 9.60086 32.2256 9.61534 32.2318 9.60914C32.2325 9.60845 32.2332 9.59397 32.227 9.60017Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5432 9.73787C34.5425 9.73856 34.5418 9.75304 34.548 9.74683C34.5487 9.74614 34.5494 9.73167 34.5432 9.73787Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5568 9.77937C34.5561 9.78006 34.5555 9.79454 34.5617 9.78834C34.5623 9.78765 34.563 9.77317 34.5568 9.77937Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2363 9.81152C32.2439 9.8341 32.2413 9.83151 32.2639 9.8391V9.81152H32.2363Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5707 9.87605C34.5701 9.87674 34.5694 9.89122 34.5756 9.88502C34.5763 9.88433 34.577 9.86985 34.5707 9.87605Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 9.94922C32.2576 9.97179 32.255 9.96921 32.2776 9.97679V9.94922H32.25Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3095 10.2481C32.3088 10.2488 32.3081 10.2633 32.3143 10.2571C32.315 10.2564 32.3157 10.2419 32.3095 10.2481Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3326 10.3766L32.3188 10.4317H32.3326C32.3392 10.4052 32.3406 10.4016 32.3326 10.3766Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3421 10.5055C32.3359 10.5117 32.3504 10.511 32.3511 10.5103C32.3573 10.5041 32.3428 10.5048 32.3421 10.5055Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7775 10.5513C34.7768 10.552 34.7761 10.5665 34.7823 10.5603C34.783 10.5596 34.7837 10.5451 34.7775 10.5513Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3923 10.7442C32.3916 10.7449 32.3909 10.7594 32.3971 10.7532C32.3978 10.7525 32.3985 10.738 32.3923 10.7442Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4062 10.7995C32.4055 10.8001 32.4048 10.8146 32.411 10.8084C32.4117 10.8077 32.4124 10.7933 32.4062 10.7995Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4199 10.8824C32.4192 10.8831 32.4185 10.8976 32.4247 10.8914C32.4254 10.8907 32.4261 10.8762 32.4199 10.8824Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4614 11.0479C32.4607 11.0486 32.46 11.0631 32.4662 11.0569C32.4669 11.0562 32.4676 11.0417 32.4614 11.0479Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9843 11.2271C34.9836 11.2278 34.9829 11.2423 34.9891 11.2361C34.9898 11.2354 34.9905 11.2209 34.9843 11.2271Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.512 11.2451V11.2865H32.5257C32.5223 11.2665 32.5214 11.2624 32.512 11.2451Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6267 11.7095C32.626 11.7102 32.6253 11.7247 32.6315 11.7185C32.6322 11.7178 32.6329 11.7033 32.6267 11.7095Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1359 11.7232C35.1352 11.7239 35.1346 11.7384 35.1408 11.7322C35.1414 11.7315 35.1421 11.717 35.1359 11.7232Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8334 12.3848C32.8328 12.3855 32.8321 12.4 32.8383 12.3938C32.839 12.3931 32.8396 12.3786 32.8334 12.3848Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3427 12.399C35.342 12.3997 35.3413 12.4142 35.3475 12.408C35.3482 12.4073 35.3489 12.3928 35.3427 12.399Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5552 12.6436C43.3123 12.676 43.0238 12.7048 42.8395 12.8871C42.5054 13.2183 42.5121 13.863 42.5984 14.2922C42.6331 14.464 42.6991 14.6337 42.827 14.7585C43.1499 15.0737 43.8608 15.033 44.2722 14.9777C44.4891 14.9484 44.7328 14.895 44.8914 14.7328C45.0177 14.6036 45.0811 14.4388 45.1159 14.2646C45.199 13.8487 45.2136 13.2519 44.916 12.9137C44.6315 12.5904 43.9485 12.5912 43.5552 12.6436Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.569 12.6575C43.326 12.6899 43.0375 12.7186 42.8533 12.901C42.5201 13.231 42.5281 13.8652 42.6149 14.2922C42.6489 14.4587 42.7171 14.6241 42.8407 14.7448C43.1592 15.0557 43.8526 15.0184 44.2583 14.964C44.4753 14.9347 44.719 14.8813 44.8775 14.7191C45.0038 14.5899 45.0672 14.4251 45.1021 14.2509C45.1841 13.8407 45.1955 13.261 44.9021 12.9275C44.6221 12.6094 43.9564 12.6059 43.569 12.6575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9853 12.8814C32.9846 12.8821 32.9839 12.8966 32.9901 12.8904C32.9908 12.8897 32.9915 12.8752 32.9853 12.8814Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4943 12.8951C35.4936 12.8958 35.493 12.9103 35.4992 12.9041C35.4998 12.9034 35.5005 12.8889 35.4943 12.8951Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1132 20.0688C15.5598 20.0688 16.0688 20.0145 16.4919 20.1853C16.9823 20.3834 17.2872 20.8255 17.5155 21.282C17.7945 21.84 18.014 22.4266 18.2455 23.0053L18.7639 24.2875C18.8494 24.4995 18.9002 24.7146 19.1389 24.7947C19.6457 24.9651 20.2817 24.8616 20.8071 24.8528C20.9739 24.85 21.2848 24.8286 21.3565 24.646C21.4139 24.4997 21.3507 24.3037 21.3034 24.1634C21.1875 23.8201 21.0371 23.4894 20.8937 23.157L20.2201 21.5853C19.9696 20.9982 19.6969 20.3967 19.2453 19.9333C19.0357 19.7182 18.7852 19.5755 18.5323 19.4208C19.1705 19.2049 19.7839 18.8686 20.1939 18.3178C21.0354 17.1875 21.0091 15.2208 19.9523 14.2244C18.6486 12.9953 16.6528 13.203 15.0029 13.203H13.8448C13.6252 13.203 13.3771 13.1792 13.1692 13.2624C12.8474 13.3913 12.8036 13.6424 12.7636 13.9474C12.7347 14.1673 12.7556 14.4014 12.7556 14.623V15.8638V22.0541V23.8188C12.7556 24.0506 12.694 24.3888 12.7883 24.6046C12.8673 24.7856 13.1219 24.8133 13.2933 24.8373C13.7185 24.8965 14.1927 24.8969 14.6169 24.8311C14.7696 24.8074 14.9753 24.78 15.0722 24.6436C15.1725 24.5024 15.1132 24.1927 15.1132 24.0256V22.4401V20.0688ZM25.1913 15.1331V21.7645V23.7085C25.1913 23.9715 25.1248 24.3423 25.2185 24.5908C25.2909 24.7832 25.568 24.8128 25.7428 24.8373C26.1391 24.8924 26.5869 24.8993 26.9836 24.8428C27.1339 24.8214 27.3086 24.8068 27.4385 24.7202C27.6285 24.5939 27.5626 24.2932 27.5626 24.0945V22.3574V15.1331H29.7547H30.3338C30.4182 15.1331 30.5207 15.1498 30.5957 15.1035C30.7367 15.0166 30.7677 14.8281 30.7922 14.6781C30.8482 14.3324 30.8475 13.9185 30.7775 13.5752C30.7374 13.377 30.6478 13.2192 30.4303 13.2042C29.7844 13.1597 29.1202 13.203 28.4726 13.203H24.5709H22.9165C22.7022 13.203 22.3849 13.1449 22.1863 13.2357C22.0413 13.3019 22.0012 13.5032 21.9779 13.6441C21.9211 13.9874 21.923 14.391 21.9848 14.7333C22.0093 14.8686 22.051 15.0452 22.1858 15.1129C22.2638 15.1522 22.3766 15.1331 22.4615 15.1331H23.0544H25.1913Z",
    fill: "#F37E21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1921 13.5567C33.1914 13.5574 33.1907 13.5719 33.1969 13.5657C33.1976 13.565 33.1983 13.5505 33.1921 13.5567Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7011 13.5709C35.7004 13.5716 35.6997 13.586 35.7059 13.5798C35.7066 13.5792 35.7073 13.5647 35.7011 13.5709Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8391 14.0255C35.8384 14.0262 35.8377 14.0406 35.8439 14.0344C35.8446 14.0337 35.8453 14.0193 35.8391 14.0255Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3989 14.2325C33.3982 14.2331 33.3975 14.2476 33.4037 14.2414C33.4044 14.2407 33.4051 14.2262 33.3989 14.2325ZM35.9036 14.2231V14.2645H35.9174C35.9139 14.2445 35.9131 14.2404 35.9036 14.2231Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5505 14.7286C33.5498 14.7293 33.5491 14.7438 33.5553 14.7376C33.556 14.7369 33.5567 14.7224 33.5505 14.7286Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0595 14.7428C36.0588 14.7434 36.0581 14.7579 36.0643 14.7517C36.065 14.751 36.0657 14.7365 36.0595 14.7428Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.113 15.0088V18.3038C15.9317 18.3038 16.9074 18.4491 17.636 17.9947C18.5015 17.4549 18.6228 15.8841 17.7049 15.3186C17.2654 15.0477 16.7557 15.0346 16.2573 15.0224C15.8764 15.0131 15.4949 15.0088 15.113 15.0088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7573 15.4044C33.7566 15.4051 33.7559 15.4195 33.7621 15.4133C33.7628 15.4126 33.7635 15.3982 33.7573 15.4044Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2665 15.418C36.2659 15.4187 36.2652 15.4332 36.2714 15.427C36.2721 15.4263 36.2728 15.4118 36.2665 15.418Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9089 15.9005C33.9082 15.9012 33.9075 15.9156 33.9137 15.9094C33.9144 15.9087 33.9151 15.8943 33.9089 15.9005Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4457 16.0109C36.4451 16.0116 36.4444 16.026 36.4506 16.0198C36.4513 16.0192 36.452 16.0047 36.4457 16.0109ZM49.1527 17.4216V16.6771C49.1527 16.5608 49.1752 16.43 49.097 16.3337C49.0077 16.2242 48.8573 16.1989 48.7253 16.1774C48.3968 16.1241 47.991 16.1179 47.6637 16.1808C47.5169 16.2089 47.3314 16.2384 47.2565 16.3876C47.181 16.5375 47.2225 16.776 47.2225 16.9391V18.1937V22.7019V24.0668C47.2225 24.2368 47.1753 24.4947 47.2678 24.6457C47.3637 24.802 47.5967 24.8213 47.7602 24.8448C48.1154 24.8956 48.5064 24.8827 48.8631 24.8539C49.0267 24.8406 49.2171 24.8249 49.3595 24.7358C49.5208 24.635 49.4835 24.4523 49.4835 24.2874V23.1431V20.3858V19.5723C49.4835 19.4664 49.4558 19.3137 49.4937 19.2139C49.5509 19.0636 49.7329 18.9195 49.838 18.8003C50.2704 18.3098 50.8564 17.8294 51.5516 18.0127C52.2955 18.2092 52.4753 19.0902 52.4753 19.7516V23.3223V24.2461C52.4753 24.377 52.4499 24.5456 52.5294 24.6591C52.6311 24.8049 52.8525 24.8217 53.013 24.8448C53.2453 24.8778 53.4821 24.8665 53.7161 24.8665C53.9761 24.8665 54.2694 24.8744 54.5157 24.7774C54.7544 24.6833 54.7225 24.4897 54.7225 24.2736V23.0052V20.3996V19.5999C54.7225 19.4865 54.6968 19.3368 54.7296 19.2277C54.7761 19.0726 54.9836 18.9006 55.0946 18.7865C55.4377 18.4342 55.8382 18.0103 56.3631 17.9743C56.4871 17.9658 56.6142 17.9712 56.7354 17.9991C57.4475 18.163 57.636 18.8887 57.7103 19.5172C57.7578 19.9196 57.7142 20.3527 57.7142 20.758V23.2396V24.0944C57.7142 24.2514 57.6949 24.4229 57.7298 24.5769C57.7768 24.785 58.0489 24.8177 58.2244 24.8427C58.589 24.8946 58.9885 24.8834 59.3549 24.8539C59.5198 24.8406 59.7276 24.8227 59.8645 24.7198C59.9667 24.6428 59.9615 24.5408 59.9615 24.4253V23.8876V21.4749V19.6964C59.9615 18.9456 59.941 18.1747 59.6263 17.4768C59.0252 16.1432 57.372 15.6693 56.0598 16.2008C55.385 16.4741 54.8702 16.9568 54.3641 17.463C54.3124 17.2836 54.1859 17.1166 54.0785 16.9666C53.3795 15.9902 51.8731 15.7689 50.8071 16.2008C50.1594 16.4631 49.6399 16.9344 49.1527 17.4216Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1387 17.4355V16.691C49.1387 16.5747 49.1613 16.4439 49.0831 16.3475C48.9938 16.2381 48.8434 16.2128 48.7113 16.1912C48.3848 16.1383 47.9888 16.135 47.6636 16.1974C47.5205 16.2247 47.3427 16.2567 47.2701 16.4015C47.1946 16.5514 47.2362 16.7899 47.2362 16.9529V18.2075V22.6882V24.0531C47.2362 24.223 47.1889 24.481 47.2815 24.632C47.3749 24.7845 47.6 24.8062 47.7601 24.829C48.112 24.8791 48.4956 24.8686 48.8492 24.8402C49.0128 24.8269 49.2032 24.8112 49.3455 24.7221C49.5068 24.6213 49.4696 24.4386 49.4696 24.2737V23.1156V20.3721V19.5586C49.4696 19.4527 49.4419 19.3 49.4798 19.2002C49.537 19.0499 49.719 18.9058 49.8241 18.7866C50.2658 18.2856 50.8576 17.8124 51.5652 17.999C52.3025 18.1936 52.4889 19.0663 52.4889 19.7241V23.2949V24.2324C52.4889 24.3633 52.4636 24.5319 52.543 24.6454C52.6423 24.7876 52.856 24.8066 53.0128 24.829C53.2456 24.8621 53.4812 24.8528 53.7159 24.8528C53.9713 24.8528 54.2598 24.8591 54.5018 24.7637C54.7358 24.6713 54.7086 24.4865 54.7086 24.2737V23.0191V20.3858V19.5862C54.7086 19.4728 54.6829 19.3231 54.7157 19.214C54.7622 19.0589 54.9697 18.8869 55.0807 18.7728C55.4233 18.4209 55.8343 17.9832 56.363 17.9599C56.5367 17.9523 56.7073 17.9637 56.8731 18.0195C57.493 18.228 57.6869 18.951 57.7267 19.5311C57.7534 19.9224 57.7279 20.3243 57.7279 20.7167V23.1018V24.0531C57.7279 24.2187 57.7067 24.4009 57.7434 24.5632C57.7892 24.7661 58.0517 24.803 58.2242 24.8269C58.5861 24.8774 58.9773 24.8695 59.3409 24.8402C59.5036 24.8271 59.6977 24.8085 59.8371 24.7152C60.0025 24.6048 59.9476 24.3495 59.9476 24.1772V22.702V20.2618C59.9476 19.6955 59.9701 19.128 59.8962 18.566C59.8006 17.8384 59.5412 17.0817 58.9549 16.6009C57.9538 15.78 56.4826 15.8695 55.4393 16.549C55.1746 16.7213 54.9233 16.9292 54.695 17.1472C54.5843 17.253 54.4918 17.4108 54.3501 17.4768C54.2417 17.1008 53.9016 16.7329 53.5919 16.5118C52.6987 15.8738 51.4267 15.8628 50.4761 16.3782C50.1259 16.5679 49.8241 16.8233 49.5248 17.0829C49.4 17.1911 49.289 17.3655 49.1387 17.4355Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4586 16.159C43.2413 16.1874 42.9252 16.1845 42.7746 16.374C42.6567 16.5224 42.7141 16.8295 42.7141 17.0079V18.6485V23.1154V24.2322C42.7141 24.3757 42.6832 24.5689 42.7882 24.6845C42.8955 24.8026 43.0896 24.8214 43.238 24.8426C43.6462 24.9006 44.1124 24.895 44.5201 24.835C44.6697 24.8129 44.875 24.7802 44.9534 24.632C45.033 24.4817 44.9751 24.1801 44.9751 24.0116V22.4674V18.0005V16.8424C44.9751 16.7091 45.0172 16.4905 44.9341 16.3777C44.8507 16.2643 44.6789 16.2226 44.5477 16.1981C44.2082 16.1347 43.8022 16.1138 43.4586 16.159Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4723 16.1728C43.255 16.2012 42.9389 16.1983 42.7883 16.3878C42.6704 16.5362 42.7278 16.8433 42.7278 17.0217V18.6347V23.1016V24.2184C42.7278 24.3619 42.697 24.5551 42.8019 24.6708C42.9093 24.7888 43.1034 24.8076 43.2517 24.8288C43.6519 24.8858 44.1069 24.8801 44.5063 24.8212C44.6559 24.7991 44.8612 24.7664 44.9396 24.6182C45.0192 24.4679 44.9613 24.1663 44.9613 23.9978V22.4812V18.0143V16.8562C44.9613 16.7229 45.0033 16.5043 44.9203 16.3915C44.8369 16.2781 44.665 16.2364 44.5339 16.2119C44.2025 16.15 43.8079 16.1286 43.4723 16.1728Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5146 16.2178C36.514 16.2185 36.5133 16.233 36.5195 16.2268C36.5202 16.2261 36.5209 16.2116 36.5146 16.2178Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6066 16.5117C36.6717 16.5922 36.9321 16.5803 37.034 16.5944C37.375 16.6417 37.7175 16.7389 38.0404 16.8571C39.1568 17.2664 40.4438 18.3588 39.9092 19.6827C39.8117 19.9239 39.6652 20.1347 39.496 20.3307C39.2442 20.6222 38.9149 20.8473 38.5781 21.0295C38.4446 21.1017 38.1559 21.1625 38.068 21.2819C39.1234 20.9249 40.2253 19.982 40.0197 18.759C39.9868 18.5627 39.912 18.3838 39.8222 18.2075C39.714 17.9947 39.552 17.7922 39.3777 17.6297C38.8273 17.1168 38.1309 16.8197 37.4062 16.6479C37.1439 16.5858 36.8642 16.5841 36.6066 16.5117Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1157 16.5762C34.115 16.5769 34.1143 16.5914 34.1205 16.5852C34.1212 16.5845 34.1219 16.57 34.1157 16.5762Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6554 21.5992V21.5854C35.4119 21.5853 35.1627 21.5337 34.9247 21.4862C34.1687 21.3349 33.4066 21.021 32.8429 20.482C32.1364 19.8063 31.9444 18.836 32.522 18.0147C32.688 17.7787 32.8995 17.5716 33.1325 17.4022C33.4566 17.1668 33.8135 16.9715 34.194 16.8428C34.1248 16.8225 34.0379 16.8776 33.9734 16.9035C33.7878 16.9777 33.6078 17.0665 33.4358 17.1682C32.704 17.6012 32.0492 18.3485 32.1576 19.2555C32.3121 20.5483 33.7249 21.2654 34.8696 21.4944C35.1269 21.5458 35.3923 21.5992 35.6554 21.5992ZM36.717 16.8704V16.8841C37.7171 16.9631 38.9756 17.4205 39.4838 18.3455C39.971 19.2324 39.4016 20.1313 38.6196 20.6038C38.4342 20.7158 38.166 20.9021 37.944 20.9099C37.9961 20.9456 38.0547 20.9118 38.1095 20.8899C38.2413 20.8372 38.3714 20.7737 38.4955 20.705C39.0068 20.4215 39.5106 19.9869 39.6503 19.3933C39.9624 18.0684 38.511 17.254 37.4339 16.9927C37.202 16.9364 36.9567 16.8754 36.717 16.8704Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7307 16.8838V16.9665C36.7931 17.0379 36.8302 17.1895 36.8272 17.2836C36.8717 17.3339 36.8844 17.3967 36.8824 17.4628C36.9665 17.559 37.038 17.8318 37.034 17.9592C37.0771 18.0084 37.0897 18.0739 37.0892 18.1384C37.1733 18.2345 37.2448 18.5074 37.2408 18.6347C37.2839 18.684 37.2965 18.7495 37.296 18.8139C37.3501 18.8758 37.3792 18.9942 37.3787 19.0759C37.429 19.1334 37.4545 19.2346 37.4476 19.3103C37.5317 19.4064 37.6032 19.6792 37.5993 19.8066C37.6424 19.8559 37.6549 19.9214 37.6544 19.9858C37.7166 20.0572 37.7539 20.2088 37.7509 20.3029C37.7954 20.3532 37.8081 20.416 37.8061 20.4821C37.8917 20.58 37.9284 20.7965 37.9577 20.9233C38.9412 20.6548 39.9815 19.6367 39.5839 18.552C39.5236 18.3876 39.4346 18.2352 39.3271 18.097C38.7429 17.3439 37.6563 16.9569 36.7307 16.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7766 17.0865C36.7759 17.0872 36.7752 17.1017 36.7814 17.0955C36.7821 17.0948 36.7828 17.0803 36.7766 17.0865Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5311 21.1994C35.2768 21.2592 34.8801 21.1234 34.635 21.0481C33.8068 20.7934 32.8112 20.3167 32.5794 19.3934C32.3709 18.5637 32.9687 17.8599 33.6424 17.4634C33.8266 17.355 34.0851 17.1813 34.3041 17.1737C34.2517 17.1378 34.1938 17.1723 34.1387 17.1933C34.0112 17.2419 33.8871 17.3 33.7664 17.3636C33.2524 17.635 32.7585 18.0485 32.5811 18.6213C32.5391 18.7571 32.5256 18.8936 32.5256 19.0349C32.5256 20.0279 33.4187 20.6166 34.249 20.9457C34.5511 21.0655 34.8794 21.1439 35.2003 21.1936C35.2804 21.206 35.472 21.2671 35.5311 21.1994Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5174 21.213C35.5039 21.0575 35.4316 20.8928 35.3842 20.7442L35.1731 20.0549L34.5837 18.1247C34.4873 17.8045 34.3657 17.4854 34.2904 17.1597C33.9839 17.2434 33.6805 17.4139 33.4218 17.5952C33.2091 17.7441 33.0177 17.9167 32.8617 18.1247C32.379 18.7684 32.4653 19.5942 33.0221 20.1652C33.5028 20.6577 34.1656 20.9486 34.828 21.101C35.0514 21.1525 35.2871 21.2123 35.5174 21.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4741 17.7481C34.4734 17.7488 34.4727 17.7633 34.4789 17.7571C34.4796 17.7564 34.4803 17.7419 34.4741 17.7481Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9833 17.7617C36.9833 17.7617 36.9819 17.7769 36.9881 17.7707C36.9881 17.7707 36.9895 17.7555 36.9833 17.7617Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6809 18.4234C34.6802 18.4241 34.6795 18.4386 34.6857 18.4324C34.6864 18.4317 34.6871 18.4172 34.6809 18.4234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1901 18.4376C37.1894 18.4383 37.1888 18.4527 37.195 18.4465C37.1956 18.4458 37.1963 18.4314 37.1901 18.4376Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8327 18.92C34.832 18.9207 34.8313 18.9352 34.8375 18.929C34.8382 18.9283 34.8389 18.9138 34.8327 18.92Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3417 18.9337C37.3411 18.9344 37.3404 18.9488 37.3466 18.9426C37.3473 18.9419 37.3479 18.9275 37.3417 18.9337Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4246 19.1958C37.4239 19.1965 37.4232 19.211 37.4294 19.2048C37.4301 19.2041 37.4308 19.1896 37.4246 19.1958Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.998 19.4576C34.9973 19.4583 34.9966 19.4728 35.0028 19.4666C35.0035 19.4659 35.0042 19.4514 34.998 19.4576Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0395 19.5953C35.0388 19.596 35.0381 19.6105 35.0443 19.6043C35.045 19.6036 35.0457 19.5891 35.0395 19.5953Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5485 19.6095C37.5478 19.6101 37.5472 19.6246 37.5534 19.6184C37.554 19.6177 37.5547 19.6032 37.5485 19.6095Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1911 20.0919C35.1904 20.0926 35.1897 20.107 35.1959 20.1008C35.1966 20.1001 35.1973 20.0857 35.1911 20.0919Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7001 20.1055C37.6995 20.1062 37.6988 20.1207 37.705 20.1145C37.7057 20.1138 37.7063 20.0993 37.7001 20.1055Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3979 20.7672C35.3972 20.7679 35.3965 20.7823 35.4027 20.7761C35.4034 20.7754 35.4041 20.761 35.3979 20.7672Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9072 20.7813C37.9065 20.782 37.9058 20.7965 37.912 20.7903C37.9127 20.7896 37.9134 20.7751 37.9072 20.7813Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0772 21.3281C38.071 21.3343 38.0855 21.3336 38.0862 21.3329C38.0924 21.3267 38.0779 21.3274 38.0772 21.3281Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1415 21.5396C38.1409 21.5403 38.1402 21.5548 38.1464 21.5486C38.1471 21.5479 38.1478 21.5334 38.1415 21.5396Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2104 21.7462C38.2097 21.7469 38.209 21.7613 38.2152 21.7551C38.2159 21.7544 38.2166 21.74 38.2104 21.7462Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.715 21.8013C35.7143 21.802 35.7137 21.8165 35.7199 21.8103C35.7206 21.8096 35.7212 21.7951 35.715 21.8013Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2656 21.9532C38.2649 21.9539 38.2642 21.9684 38.2704 21.9622C38.2711 21.9615 38.2718 21.947 38.2656 21.9532Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8666 22.2979C35.866 22.2986 35.8653 22.3131 35.8715 22.3069C35.8722 22.3062 35.8729 22.2917 35.8666 22.2979Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9494 22.5733C35.9487 22.574 35.948 22.5885 35.9542 22.5823C35.9549 22.5816 35.9556 22.5671 35.9494 22.5733Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9631 22.6148C35.9624 22.6155 35.9617 22.63 35.9679 22.6238C35.9686 22.6231 35.9693 22.6086 35.9631 22.6148Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4724 22.6285C38.4717 22.6292 38.471 22.6437 38.4772 22.6375C38.4779 22.6368 38.4786 22.6223 38.4724 22.6285Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1147 23.1109C36.114 23.1116 36.1133 23.1261 36.1195 23.1199C36.1202 23.1192 36.1209 23.1047 36.1147 23.1109Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.624 23.1251C38.6233 23.1258 38.6226 23.1402 38.6288 23.134C38.6295 23.1333 38.6302 23.1189 38.624 23.1251Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3215 23.7867C36.3208 23.7874 36.3201 23.8019 36.3263 23.7957C36.327 23.795 36.3277 23.7805 36.3215 23.7867Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8308 23.8004C38.8301 23.8011 38.8294 23.8155 38.8356 23.8093C38.8363 23.8086 38.837 23.7942 38.8308 23.8004Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9824 24.297C38.9817 24.2976 38.981 24.3121 38.9872 24.3059C38.9879 24.3052 38.9886 24.2907 38.9824 24.297Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5283 24.4625C36.5276 24.4632 36.5269 24.4776 36.5331 24.4714C36.5338 24.4708 36.5345 24.4563 36.5283 24.4625Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6801 24.9586C36.6794 24.9593 36.6787 24.9737 36.6849 24.9675C36.6856 24.9668 36.6863 24.9524 36.6801 24.9586Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1892 24.9722C39.1885 24.9729 39.1878 24.9874 39.194 24.9812C39.1947 24.9805 39.1954 24.966 39.1892 24.9722Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8869 25.6344C36.8862 25.635 36.8855 25.6495 36.8917 25.6433C36.8924 25.6426 36.8931 25.6282 36.8869 25.6344Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3959 25.648C39.3953 25.6487 39.3946 25.6632 39.4008 25.657C39.4015 25.6563 39.4021 25.6418 39.3959 25.648Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0385 26.1304C37.0378 26.1311 37.0371 26.1456 37.0433 26.1394C37.044 26.1387 37.0447 26.1242 37.0385 26.1304Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5478 26.1441C39.5471 26.1448 39.5464 26.1593 39.5526 26.1531C39.5533 26.1524 39.554 26.1379 39.5478 26.1441Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6442 26.4888C39.6435 26.4895 39.6429 26.504 39.6491 26.4978C39.6497 26.4971 39.6504 26.4826 39.6442 26.4888Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2453 26.8062C37.2446 26.8069 37.2439 26.8214 37.2501 26.8152C37.2508 26.8145 37.2515 26.8 37.2453 26.8062Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7822 26.9576C39.7815 26.9583 39.7808 26.9728 39.787 26.9666C39.7877 26.9659 39.7884 26.9514 39.7822 26.9576Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3969 27.3023C37.3962 27.303 37.3955 27.3175 37.4017 27.3113C37.4024 27.3106 37.4031 27.2961 37.3969 27.3023Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9292 27.6377V27.6653H39.9567C39.9491 27.6427 39.9517 27.6451 39.9292 27.6377Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9338 27.6886C39.9331 27.6892 39.9324 27.7037 39.9386 27.6975C39.9393 27.6968 39.94 27.6823 39.9338 27.6886Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9614 27.7847C39.9607 27.7854 39.96 27.7999 39.9662 27.7937C39.9669 27.793 39.9676 27.7785 39.9614 27.7847Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9612 27.8262C39.9606 27.8269 39.9599 27.8414 39.9661 27.8352C39.9668 27.8345 39.9674 27.82 39.9612 27.8262Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9889 27.9087C39.9883 27.9094 39.9876 27.9239 39.9938 27.9177C39.9945 27.917 39.9951 27.9025 39.9889 27.9087Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0026 27.9918C40.0019 27.9925 40.0012 28.0069 40.0074 28.0007C40.0081 28 40.0088 27.9856 40.0026 27.9918Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0165 28.088C40.0159 28.0887 40.0152 28.1031 40.0214 28.0969C40.0221 28.0962 40.0228 28.0818 40.0165 28.088Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0302 28.1846C40.0295 28.1853 40.0288 28.1998 40.035 28.1936C40.0357 28.1929 40.0364 28.1784 40.0302 28.1846Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0302 28.2398C40.0295 28.2405 40.0289 28.255 40.0351 28.2488C40.0357 28.2481 40.0364 28.2336 40.0302 28.2398Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0439 28.2672C40.0432 28.2679 40.0425 28.2823 40.0487 28.2761C40.0494 28.2754 40.0501 28.261 40.0439 28.2672Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6865 28.295C37.6858 28.2957 37.6851 28.3102 37.6913 28.304C37.692 28.3033 37.6927 28.2888 37.6865 28.295Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0533 28.3408L40.0396 28.3684H40.0671C40.0671 28.3429 40.0713 28.3498 40.0533 28.3408Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0578 28.419C40.0571 28.4197 40.0564 28.4342 40.0626 28.428C40.0633 28.4273 40.064 28.4128 40.0578 28.419Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0626 28.497C40.0564 28.5032 40.0708 28.5025 40.0715 28.5018C40.0777 28.4956 40.0633 28.4963 40.0626 28.497Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0715 28.5709C40.0708 28.5716 40.0701 28.586 40.0763 28.5798C40.077 28.5792 40.0777 28.5647 40.0715 28.5709Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0716 28.6118C40.071 28.6125 40.0703 28.627 40.0765 28.6208C40.0772 28.6201 40.0779 28.6056 40.0716 28.6118Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0808 28.6992V28.7406H40.0946C40.0912 28.7206 40.0901 28.7165 40.0808 28.6992Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0853 28.75C40.0846 28.7507 40.084 28.7652 40.0902 28.759C40.0908 28.7583 40.0915 28.7438 40.0853 28.75Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0854 28.7774C40.0847 28.7781 40.084 28.7926 40.0902 28.7864C40.0909 28.7857 40.0916 28.7712 40.0854 28.7774Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8381 28.7911C37.8374 28.7918 37.8367 28.8063 37.8429 28.8001C37.8436 28.7994 37.8443 28.7849 37.8381 28.7911Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0991 28.8463C40.0984 28.847 40.0977 28.8614 40.1039 28.8552C40.1046 28.8545 40.1053 28.8401 40.0991 28.8463Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.852 28.8604C37.8513 28.8611 37.8506 28.8756 37.8568 28.8694C37.8575 28.8687 37.8582 28.8542 37.852 28.8604Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0991 28.9014C40.0984 28.9021 40.0977 28.9166 40.1039 28.9104C40.1046 28.9097 40.1053 28.8952 40.0991 28.9014Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 28.9566C40.1123 28.9573 40.1116 28.9718 40.1178 28.9656C40.1185 28.9649 40.1192 28.9504 40.113 28.9566Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0992 28.9844C40.0985 28.9851 40.0978 28.9996 40.104 28.9934C40.1047 28.9927 40.1054 28.9782 40.0992 28.9844Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 28.9981C40.1123 28.9988 40.1116 29.0133 40.1178 29.0071C40.1185 29.0064 40.1192 28.9919 40.113 28.9981Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0991 29.0118C40.0984 29.0125 40.0977 29.027 40.1039 29.0208C40.1046 29.0201 40.1053 29.0056 40.0991 29.0118Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.0533C40.1123 29.054 40.1116 29.0685 40.1178 29.0623C40.1185 29.0616 40.1192 29.0471 40.113 29.0533Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9208 29.1085C37.9202 29.1092 37.9195 29.1236 37.9257 29.1174C37.9264 29.1167 37.9271 29.1023 37.9208 29.1085Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.1773C40.1123 29.178 40.1116 29.1925 40.1178 29.1863C40.1185 29.1856 40.1192 29.1711 40.113 29.1773Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1084 29.2095V29.2508H40.1222C40.1187 29.2308 40.1177 29.2267 40.1084 29.2095Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.3292C40.1123 29.3299 40.1116 29.3443 40.1178 29.3381C40.1185 29.3375 40.1192 29.323 40.113 29.3292Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9714 29.3608C37.979 29.3834 37.9764 29.381 37.999 29.3884V29.3608H37.9714Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.398C40.1123 29.3987 40.1116 29.4132 40.1178 29.407C40.1185 29.4063 40.1192 29.3918 40.113 29.398Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1085 29.4438V29.4852H40.1223C40.1189 29.4652 40.118 29.4611 40.1085 29.4438Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.5084C40.1123 29.5091 40.1116 29.5235 40.1178 29.5173C40.1185 29.5167 40.1192 29.5022 40.113 29.5084Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1084 29.54V29.5814H40.1222C40.1188 29.5614 40.1179 29.5573 40.1084 29.54Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1084 29.6094V29.6507H40.1222C40.1187 29.6307 40.1177 29.6266 40.1084 29.6094Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.113 29.6734C40.1123 29.6741 40.1116 29.6886 40.1178 29.6824C40.1185 29.6817 40.1192 29.6672 40.113 29.6734Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0725 29.7012C38.0718 29.7019 38.0711 29.7164 38.0773 29.7102C38.078 29.7095 38.0787 29.695 38.0725 29.7012Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0991 29.8116C40.0984 29.8123 40.0977 29.8268 40.1039 29.8206C40.1046 29.8199 40.1053 29.8054 40.0991 29.8116Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0947 29.8438V29.8851H40.1085C40.1051 29.8651 40.104 29.861 40.0947 29.8438Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0991 29.922C40.0984 29.9226 40.0977 29.9371 40.1039 29.9309C40.1046 29.9302 40.1053 29.9157 40.0991 29.922Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1415 29.963C38.1409 29.9637 38.1402 29.9781 38.1464 29.9719C38.1471 29.9712 38.1478 29.9568 38.1415 29.963Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0902 29.9858C40.084 29.992 40.0984 29.9913 40.0991 29.9906C40.1053 29.9844 40.0909 29.9851 40.0902 29.9858Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0854 30.046C40.0847 30.0467 40.084 30.0611 40.0902 30.0549C40.0909 30.0542 40.0916 30.0398 40.0854 30.046Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0808 30.0781V30.1195H40.0946C40.0912 30.0995 40.0901 30.0954 40.0808 30.0781Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0765 30.1376C40.0703 30.1438 40.0848 30.1432 40.0855 30.1425C40.0917 30.1363 40.0772 30.137 40.0765 30.1376Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0671 30.1606V30.202H40.0809C40.0775 30.182 40.0764 30.1779 40.0671 30.1606Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1921 30.2158V30.2434C38.2145 30.236 38.2123 30.2384 38.2197 30.2158H38.1921Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0715 30.2388C40.0708 30.2395 40.0701 30.254 40.0763 30.2478C40.077 30.2471 40.0777 30.2326 40.0715 30.2388Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0489 30.3305C40.0427 30.3367 40.0572 30.336 40.0579 30.3353C40.0641 30.3291 40.0496 30.3298 40.0489 30.3305Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0396 30.3535V30.3949H40.0533C40.0499 30.3749 40.0489 30.3707 40.0396 30.3535Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0396 30.4087V30.4501H40.0533C40.0499 30.4301 40.0489 30.4259 40.0396 30.4087Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2792 30.5562C38.2786 30.5569 38.2779 30.5714 38.2841 30.5652C38.2848 30.5645 38.2854 30.55 38.2792 30.5562Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0165 30.5836C40.0159 30.5843 40.0152 30.5987 40.0214 30.5925C40.0221 30.5918 40.0228 30.5774 40.0165 30.5836Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0074 30.6201C40.0012 30.6263 40.0157 30.6256 40.0164 30.6249C40.0226 30.6187 40.0081 30.6194 40.0074 30.6201Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.998 30.6431V30.6844H40.0118C40.0084 30.6644 40.0074 30.6603 39.998 30.6431Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3068 30.7213C38.3061 30.722 38.3055 30.7364 38.3117 30.7302C38.3123 30.7295 38.313 30.7151 38.3068 30.7213Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.989 30.7354C39.9883 30.7361 39.9876 30.7506 39.9938 30.7444C39.9945 30.7437 39.9952 30.7292 39.989 30.7354Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9798 30.7719C39.9736 30.7781 39.9881 30.7774 39.9888 30.7767C39.995 30.7705 39.9805 30.7712 39.9798 30.7719Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3344 30.7906C38.3337 30.7913 38.333 30.8058 38.3392 30.7996C38.3399 30.7989 38.3406 30.7844 38.3344 30.7906Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.975 30.8043C39.9744 30.805 39.9737 30.8194 39.9799 30.8132C39.9806 30.8125 39.9812 30.7981 39.975 30.8043Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3344 30.8453C38.3337 30.846 38.333 30.8605 38.3392 30.8543C38.3399 30.8536 38.3406 30.8391 38.3344 30.8453Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9522 30.8681C39.946 30.8743 39.9605 30.8736 39.9612 30.8729C39.9674 30.8667 39.9529 30.8674 39.9522 30.8681Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9431 30.8916V30.9192H39.9707C39.9631 30.8966 39.9657 30.899 39.9431 30.8916Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3574 30.9189V30.9603H38.3712C38.3678 30.9403 38.3669 30.9362 38.3574 30.9189Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9475 30.942C39.9468 30.9427 39.9461 30.9571 39.9523 30.9509C39.953 30.9502 39.9537 30.9358 39.9475 30.942Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3483 30.9556C38.3476 30.9563 38.347 30.9708 38.3532 30.9646C38.3538 30.9639 38.3545 30.9494 38.3483 30.9556Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9292 30.9604V31.0018H39.943C39.9395 30.9818 39.9387 30.9777 39.9292 30.9604Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9246 31.0063C39.9184 31.0125 39.9329 31.0118 39.9336 31.0111C39.9398 31.0049 39.9253 31.0056 39.9246 31.0063Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9155 31.0293V31.0707H39.9293C39.9259 31.0507 39.925 31.0465 39.9155 31.0293Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3574 31.043V31.0705C38.3798 31.0631 38.3776 31.0654 38.385 31.043H38.3574Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9017 31.0981L39.8879 31.1257H39.9155C39.9155 31.1002 39.9196 31.1071 39.9017 31.0981Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3759 31.1348C38.3752 31.1355 38.3745 31.15 38.3807 31.1438C38.3814 31.1431 38.3821 31.1286 38.3759 31.1348Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8786 31.19C39.8779 31.1907 39.8772 31.2052 39.8834 31.199C39.8841 31.1983 39.8848 31.1838 39.8786 31.19Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8786 31.2179C39.8779 31.2185 39.8772 31.233 39.8834 31.2268C39.8841 31.2261 39.8848 31.2116 39.8786 31.2179Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8647 31.2315C39.864 31.2322 39.8633 31.2467 39.8695 31.2405C39.8702 31.2398 39.8709 31.2253 39.8647 31.2315Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3896 31.273C38.3889 31.2737 38.3882 31.2882 38.3944 31.282C38.3951 31.2813 38.3958 31.2668 38.3896 31.273Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.851 31.2867C39.8503 31.2874 39.8496 31.3019 39.8558 31.2957C39.8565 31.295 39.8572 31.2805 39.851 31.2867Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4033 31.3145C38.4026 31.3152 38.4019 31.3296 38.4081 31.3234C38.4088 31.3228 38.4095 31.3083 38.4033 31.3145ZM39.8326 31.3052V31.3465H39.8464C39.843 31.3265 39.8421 31.3224 39.8326 31.3052Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3896 31.3282C38.3889 31.3289 38.3882 31.3434 38.3944 31.3372C38.3951 31.3365 38.3958 31.322 38.3896 31.3282Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8282 31.351C39.822 31.3572 39.8365 31.3565 39.8372 31.3558C39.8434 31.3496 39.8289 31.3503 39.8282 31.351Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4033 31.3697C38.4026 31.3703 38.4019 31.3848 38.4081 31.3786C38.4088 31.3779 38.4095 31.3635 38.4033 31.3697Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.385 31.4702C38.3924 31.4928 38.3902 31.4904 38.4126 31.4978V31.4702H38.385Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7776 31.4844V31.5257H39.7914C39.7879 31.5057 39.7871 31.5016 39.7776 31.4844Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.385 31.5117L38.3988 31.5531H38.4126V31.5117H38.385Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4033 31.6036C38.4026 31.6043 38.4019 31.6188 38.4081 31.6126C38.4088 31.6119 38.4095 31.5974 38.4033 31.6036Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4033 31.645C38.4026 31.6457 38.4019 31.6602 38.4081 31.654C38.4088 31.6533 38.4095 31.6388 38.4033 31.645Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9669 31.6494L32.9531 31.677H32.9807C32.9807 31.6515 32.9848 31.6584 32.9669 31.6494Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7318 31.6542C39.7256 31.6604 39.74 31.6598 39.7407 31.6591C39.7469 31.6529 39.7325 31.6536 39.7318 31.6542Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0313 31.6679C33.0251 31.6741 33.0396 31.6734 33.0403 31.6727C33.0465 31.6665 33.032 31.6672 33.0313 31.6679Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0728 31.6679C33.0666 31.6741 33.0811 31.6734 33.0818 31.6727C33.088 31.6665 33.0735 31.6672 33.0728 31.6679Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1004 31.6679C33.0942 31.6741 33.1087 31.6734 33.1094 31.6727C33.1156 31.6665 33.1011 31.6672 33.1004 31.6679Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1278 31.6679C33.1216 31.6741 33.136 31.6734 33.1367 31.6727C33.1429 31.6665 33.1285 31.6672 33.1278 31.6679Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.727 31.6866C39.7263 31.6873 39.7256 31.7018 39.7318 31.6956C39.7325 31.6949 39.7332 31.6804 39.727 31.6866Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3161 31.7003C33.3154 31.701 33.3147 31.7154 33.3209 31.7092C33.3216 31.7085 33.3223 31.6941 33.3161 31.7003Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4033 31.7003C38.4026 31.701 38.4019 31.7154 38.4081 31.7092C38.4088 31.7085 38.4095 31.6941 38.4033 31.7003Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3621 31.7094C33.3559 31.7156 33.3704 31.7149 33.3711 31.7142C33.3773 31.708 33.3628 31.7087 33.3621 31.7094Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4082 31.7188V31.7325H33.4496C33.4323 31.7231 33.4282 31.7222 33.4082 31.7188Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.454 31.7281C33.4534 31.7287 33.4527 31.7432 33.4589 31.737C33.4596 31.7363 33.4603 31.7219 33.454 31.7281Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7042 31.7504C39.698 31.7566 39.7125 31.756 39.7131 31.7553C39.7193 31.7491 39.7049 31.7497 39.7042 31.7504Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6314 31.7642C32.6252 31.7705 32.6397 31.7698 32.6404 31.7691C32.6466 31.7629 32.6321 31.7636 32.6314 31.7642Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5416 31.7646C33.5354 31.7708 33.5499 31.7701 33.5505 31.7694C33.5567 31.7632 33.5423 31.7639 33.5416 31.7646Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3896 31.8243C38.3889 31.825 38.3882 31.8395 38.3944 31.8333C38.3951 31.8326 38.3958 31.8181 38.3896 31.8243Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6579 31.838C39.6572 31.8387 39.6565 31.8531 39.6627 31.8469C39.6634 31.8462 39.6641 31.8318 39.6579 31.838Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4614 31.8795C32.4607 31.8802 32.46 31.8946 32.4662 31.8884C32.4669 31.8877 32.4676 31.8733 32.4614 31.8795Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6303 31.8931C39.6296 31.8938 39.6289 31.9083 39.6351 31.9021C39.6358 31.9014 39.6365 31.8869 39.6303 31.8931Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4246 31.9023C32.4184 31.9085 32.4329 31.9078 32.4336 31.9071C32.4398 31.9009 32.4253 31.9016 32.4246 31.9023Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8448 31.9023C33.8386 31.9085 33.8531 31.9078 33.8538 31.9071C33.86 31.9009 33.8455 31.9016 33.8448 31.9023ZM38.3758 31.9071C38.3751 31.9078 38.3744 31.9223 38.3806 31.9161C38.3813 31.9154 38.382 31.9009 38.3758 31.9071Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6303 31.9346C39.6296 31.9353 39.6289 31.9498 39.6351 31.9436C39.6358 31.9429 39.6365 31.9284 39.6303 31.9346Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3834 31.9575C32.3772 31.9637 32.3917 31.963 32.3923 31.9623C32.3985 31.9561 32.3841 31.9568 32.3834 31.9575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9641 31.9762C33.9634 31.9768 33.9627 31.9913 33.9689 31.9851C33.9696 31.9844 33.9703 31.9699 33.9641 31.9762Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.362 31.9898C38.3613 31.9905 38.3606 32.005 38.3668 31.9988C38.3675 31.9981 38.3682 31.9836 38.362 31.9898Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5938 31.999C39.5876 32.0052 39.6021 32.0045 39.6028 32.0038C39.609 31.9976 39.5945 31.9983 39.5938 31.999Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0515 32.0265C34.0453 32.0327 34.0598 32.032 34.0605 32.0313C34.0667 32.0251 34.0522 32.0258 34.0515 32.0265ZM38.3575 32.022V32.0633H38.3712C38.3678 32.0433 38.3669 32.0392 38.3575 32.022Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3006 32.0538C32.2944 32.06 32.3089 32.0593 32.3096 32.0586C32.3158 32.0524 32.3013 32.0531 32.3006 32.0538Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1068 32.0678C34.1006 32.074 34.115 32.0733 34.1157 32.0726C34.1219 32.0664 34.1075 32.0671 34.1068 32.0678Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5432 32.0771V32.1323H39.557C39.5546 32.109 39.5525 32.098 39.5432 32.0771Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1619 32.0952C34.1557 32.1014 34.1702 32.1007 34.1709 32.1C34.1771 32.0938 34.1626 32.0945 34.1619 32.0952Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3483 32.1002C38.3476 32.1009 38.347 32.1153 38.3532 32.1091C38.3538 32.1084 38.3545 32.094 38.3483 32.1002Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1802 32.1045C34.1878 32.1271 34.1852 32.1247 34.2078 32.1321C34.2002 32.1095 34.2028 32.1119 34.1802 32.1045Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2171 32.1367C34.2109 32.1429 34.2254 32.1422 34.2261 32.1415C34.2323 32.1353 34.2178 32.136 34.2171 32.1367Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3392 32.1367C38.333 32.1429 38.3475 32.1422 38.3482 32.1415C38.3544 32.1353 38.3399 32.136 38.3392 32.1367Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2354 32.146C34.243 32.1686 34.2406 32.1662 34.263 32.1736C34.2554 32.151 34.258 32.1534 34.2354 32.146Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.525 32.1503C39.5188 32.1565 39.5333 32.1559 39.5339 32.1552C39.5401 32.149 39.5257 32.1496 39.525 32.1503Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2318 32.1641C32.2256 32.1704 32.24 32.1697 32.2407 32.169C32.2469 32.1628 32.2325 32.1635 32.2318 32.1641Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3344 32.1827C38.3337 32.1834 38.333 32.1979 38.3392 32.1917C38.3399 32.191 38.3406 32.1765 38.3344 32.1827Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2996 32.2055C34.2934 32.2117 34.3079 32.211 34.3086 32.2103C34.3148 32.2041 34.3003 32.2048 34.2996 32.2055Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4835 32.2055C39.4773 32.2117 39.4917 32.211 39.4924 32.2103C39.4986 32.2041 39.4842 32.2048 39.4835 32.2055Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1903 32.2193C32.1841 32.2255 32.1985 32.2248 32.1992 32.2242C32.2054 32.2179 32.191 32.2186 32.1903 32.2193Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1855 32.2379C32.1848 32.2386 32.1841 32.253 32.1903 32.2468C32.191 32.2461 32.1917 32.2317 32.1855 32.2379Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3116 32.2333C38.3054 32.2396 38.3199 32.2389 38.3206 32.2382C38.3268 32.232 38.3123 32.2327 38.3116 32.2333Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3687 32.247C34.3625 32.2532 34.377 32.2525 34.3777 32.2518C34.3839 32.2456 34.3694 32.2463 34.3687 32.247Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1579 32.2794C32.1572 32.2801 32.1565 32.2945 32.1627 32.2883C32.1634 32.2876 32.1641 32.2732 32.1579 32.2794Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4239 32.2885C34.4177 32.2947 34.4322 32.294 34.4329 32.2933C34.4391 32.2871 34.4246 32.2878 34.4239 32.2885ZM38.2932 32.2933C38.2925 32.294 38.2918 32.3085 38.298 32.3023C38.2987 32.3016 38.2994 32.2871 38.2932 32.2933Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4791 32.3295C34.4729 32.3357 34.4874 32.3351 34.488 32.3344C34.4942 32.3282 34.4798 32.3288 34.4791 32.3295Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4146 32.3574C39.4084 32.3636 39.4229 32.3629 39.4236 32.3622C39.4298 32.356 39.4153 32.3567 39.4146 32.3574Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1166 32.3897C32.116 32.3904 32.1153 32.4049 32.1215 32.3987C32.1222 32.398 32.1229 32.3835 32.1166 32.3897Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5568 32.4034C34.5561 32.4041 34.5555 32.4186 34.5617 32.4124C34.5623 32.4117 34.563 32.3972 34.5568 32.4034ZM38.2655 32.4034C38.2648 32.4041 38.2641 32.4186 38.2703 32.4124C38.271 32.4117 38.2717 32.3972 38.2655 32.4034Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0891 32.4312C32.0884 32.4319 32.0877 32.4464 32.0939 32.4402C32.0946 32.4395 32.0953 32.425 32.0891 32.4312Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6168 32.4536C34.6106 32.4598 34.625 32.4591 34.6257 32.4584C34.6319 32.4522 34.6175 32.4529 34.6168 32.4536Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2152 32.4952C38.209 32.5014 38.2234 32.5007 38.2241 32.5C38.2303 32.4938 38.2159 32.4945 38.2152 32.4952Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0615 32.5137C32.0608 32.5144 32.0601 32.5289 32.0663 32.5227C32.067 32.522 32.0677 32.5075 32.0615 32.5137Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2058 32.5044V32.5458H38.2196C38.2161 32.5258 38.2151 32.5216 38.2058 32.5044Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7084 32.5274C34.7078 32.5281 34.7071 32.5426 34.7133 32.5364C34.714 32.5357 34.7146 32.5212 34.7084 32.5274Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0478 32.5553C32.0471 32.5559 32.0464 32.5704 32.0526 32.5642C32.0533 32.5635 32.054 32.549 32.0478 32.5553Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2995 32.5553C39.2988 32.5559 39.2981 32.5704 39.3043 32.5642C39.305 32.5635 39.3057 32.549 39.2995 32.5553Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0339 32.5689C32.0332 32.5696 32.0325 32.5841 32.0387 32.5779C32.0394 32.5772 32.0401 32.5627 32.0339 32.5689Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7636 32.5689C34.7629 32.5696 34.7622 32.5841 34.7684 32.5779C34.7691 32.5772 34.7698 32.5627 34.7636 32.5689Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2719 32.5825C39.2712 32.5832 39.2705 32.5977 39.2767 32.5915C39.2774 32.5908 39.2781 32.5763 39.2719 32.5825Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1739 32.5917C38.1677 32.5979 38.1822 32.5973 38.1829 32.5966C38.1891 32.5904 38.1746 32.5911 38.1739 32.5917Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8099 32.6054C34.8037 32.6116 34.8182 32.6109 34.8189 32.6102C34.8251 32.604 34.8106 32.6047 34.8099 32.6054Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2582 32.6104C39.2576 32.6111 39.2569 32.6256 39.2631 32.6194C39.2638 32.6187 39.2645 32.6042 39.2582 32.6104Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0156 32.6147V32.6561H32.0294C32.026 32.6361 32.0251 32.632 32.0156 32.6147Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2399 32.6284L39.2261 32.656C39.2435 32.6426 39.2452 32.6465 39.2399 32.6284Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8512 32.6469C34.8449 32.6531 34.8594 32.6524 34.8601 32.6517C34.8663 32.6455 34.8518 32.6462 34.8512 32.6469Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1463 32.6469C38.1401 32.6531 38.1546 32.6524 38.1553 32.6517C38.1615 32.6455 38.147 32.6462 38.1463 32.6469Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1415 32.6656C38.1409 32.6663 38.1402 32.6808 38.1464 32.6746C38.1471 32.6739 38.1478 32.6594 38.1415 32.6656Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9063 32.6879C34.9001 32.6941 34.9146 32.6935 34.9153 32.6928C34.9215 32.6866 34.907 32.6872 34.9063 32.6879Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.002 32.6973V32.7524H32.0157C32.0133 32.7291 32.0113 32.7181 32.002 32.6973Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9246 32.6973C34.932 32.7198 34.9296 32.7174 34.9521 32.7248C34.9446 32.7023 34.9471 32.7047 34.9246 32.6973Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1709 32.7251V32.7389H39.2123C39.195 32.7294 39.1909 32.7285 39.1709 32.7251Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0725 32.7618C38.0718 32.7625 38.0711 32.777 38.0773 32.7708C38.078 32.7701 38.0787 32.7556 38.0725 32.7618Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1527 32.7846C39.1465 32.7908 39.1609 32.7901 39.1616 32.7894C39.1678 32.7832 39.1534 32.7839 39.1527 32.7846Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0442 32.7984C35.038 32.8046 35.0525 32.8039 35.0532 32.8032C35.0594 32.797 35.0449 32.7977 35.0442 32.7984Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0579 32.8124C35.0517 32.8187 35.0662 32.818 35.0669 32.8173C35.0731 32.8111 35.0586 32.8118 35.0579 32.8124Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9787 32.8448C31.978 32.8455 31.9773 32.86 31.9835 32.8538C31.9842 32.8531 31.9849 32.8386 31.9787 32.8448Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1683 32.895C35.1621 32.9012 35.1766 32.9005 35.1773 32.8998C35.1835 32.8936 35.169 32.8943 35.1683 32.895Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0651 32.9137C39.0644 32.9143 39.0638 32.9288 39.07 32.9226C39.0706 32.9219 39.0713 32.9074 39.0651 32.9137Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2235 32.9223C35.2173 32.9285 35.2317 32.9278 35.2324 32.9271C35.2386 32.9209 35.2242 32.9216 35.2235 32.9223Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9119 32.9638C37.9057 32.97 37.9202 32.9693 37.9209 32.9686C37.9271 32.9624 37.9126 32.9631 37.9119 32.9638Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9963 32.9962C38.9956 32.9969 38.9949 33.0113 39.0011 33.0051C39.0018 33.0044 39.0025 32.99 38.9963 32.9962Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3338 33.0053C35.3276 33.0115 35.3421 33.0108 35.3428 33.0101C35.349 33.0039 35.3345 33.0046 35.3338 33.0053Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8474 33.001V33.0148H37.8888C37.8715 33.0053 37.8674 33.0044 37.8474 33.001Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9824 33.0098C38.9817 33.0105 38.981 33.025 38.9872 33.0188C38.9879 33.0181 38.9886 33.0036 38.9824 33.0098Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3614 33.0327C35.3552 33.0389 35.3697 33.0382 35.3704 33.0375C35.3766 33.0313 35.3621 33.032 35.3614 33.0327Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9835 33.0468C31.9773 33.053 31.9917 33.0523 31.9924 33.0516C31.9986 33.0454 31.9842 33.0461 31.9835 33.0468Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.389 33.0468C35.3828 33.053 35.3973 33.0523 35.398 33.0516C35.4042 33.0454 35.3897 33.0461 35.389 33.0468Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9598 33.0468C38.9536 33.053 38.9681 33.0523 38.9688 33.0516C38.975 33.0454 38.9605 33.0461 38.9598 33.0468Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4166 33.0739C35.4104 33.0801 35.4249 33.0794 35.4255 33.0788C35.4317 33.0726 35.4173 33.0732 35.4166 33.0739Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.751 33.1112H37.7648C37.7722 33.0888 37.7698 33.091 37.7923 33.0836C37.7649 33.074 37.7627 33.0838 37.751 33.1112Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9787 33.0929C31.978 33.0935 31.9773 33.108 31.9835 33.1018C31.9842 33.1011 31.9849 33.0866 31.9787 33.0929Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5634 33.148C35.5627 33.1487 35.562 33.1632 35.5683 33.157C35.5689 33.1563 35.5696 33.1418 35.5634 33.148Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.877 33.1567C38.8708 33.1629 38.8853 33.1622 38.886 33.1615C38.8922 33.1553 38.8777 33.156 38.877 33.1567Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.614 33.1938V33.2076H35.6554C35.6381 33.1983 35.634 33.1973 35.614 33.1938Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5624 33.2305C37.5618 33.2312 37.5611 33.2457 37.5673 33.2395C37.568 33.2388 37.5687 33.2243 37.5624 33.2305Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7943 33.2534C38.7881 33.2596 38.8025 33.2589 38.8032 33.2582C38.8094 33.252 38.795 33.2527 38.7943 33.2534Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7887 33.267C35.7824 33.2732 35.7969 33.2726 35.7976 33.2719C35.8038 33.2657 35.7893 33.2663 35.7887 33.267Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4934 33.272C37.4927 33.2727 37.492 33.2872 37.4982 33.281C37.4989 33.2803 37.4996 33.2658 37.4934 33.272Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8438 33.2949C35.8376 33.3011 35.8521 33.3004 35.8528 33.2997C35.859 33.2935 35.8445 33.2942 35.8438 33.2949Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4384 33.2994C37.4377 33.3001 37.437 33.3146 37.4433 33.3084C37.4439 33.3077 37.4446 33.2932 37.4384 33.2994Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7528 33.3085C38.7466 33.3147 38.761 33.3141 38.7617 33.3134C38.7679 33.3072 38.7535 33.3079 38.7528 33.3085Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9036 33.3179V33.3317H35.9449C35.9277 33.3224 35.9236 33.3213 35.9036 33.3179Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0478 33.3408C32.0471 33.3415 32.0464 33.356 32.0526 33.3498C32.0533 33.3491 32.054 33.3346 32.0478 33.3408Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.264 33.3637C37.2578 33.3699 37.2723 33.3692 37.273 33.3685C37.2792 33.3623 37.2647 33.363 37.264 33.3637Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1379 33.4004V33.4142H36.1793C36.1621 33.4047 36.1579 33.4038 36.1379 33.4004Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1792 33.4004V33.4142H36.2206C36.2033 33.4047 36.1992 33.4038 36.1792 33.4004Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2068 33.4146V33.4283H36.2481C36.2309 33.4189 36.2268 33.418 36.2068 33.4146Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2526 33.4234C36.2519 33.4241 36.2513 33.4386 36.2575 33.4324C36.2581 33.4317 36.2588 33.4172 36.2526 33.4234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0157 33.4326C37.0095 33.4388 37.024 33.4381 37.0247 33.4374C37.0309 33.4312 37.0164 33.4319 37.0157 33.4326Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2896 33.4419V33.4557H36.3309C36.3137 33.4462 36.3095 33.4453 36.2896 33.4419Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4366 33.4604C36.4304 33.4666 36.4449 33.4659 36.4456 33.4652C36.4518 33.459 36.4373 33.4597 36.4366 33.4604Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4963 33.4697V33.4835H36.5377C36.5205 33.474 36.5163 33.4732 36.4963 33.4697Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5745 33.4741C36.5683 33.4803 36.5828 33.4796 36.5835 33.4789C36.5897 33.4727 36.5752 33.4734 36.5745 33.4741Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7401 33.4741C36.7339 33.4803 36.7483 33.4796 36.749 33.4789C36.7552 33.4727 36.7408 33.4734 36.7401 33.4741Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7952 33.4741C36.789 33.4803 36.8035 33.4796 36.8042 33.4789C36.8104 33.4727 36.7959 33.4734 36.7952 33.4741Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8641 33.4741C36.8579 33.4803 36.8724 33.4796 36.8731 33.4789C36.8793 33.4727 36.8648 33.4734 36.8641 33.4741Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6297 33.4877C36.6235 33.4939 36.638 33.4933 36.6387 33.4926C36.6449 33.4864 36.6304 33.4871 36.6297 33.4877Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5827 33.5064C38.582 33.5071 38.5813 33.5216 38.5875 33.5154C38.5882 33.5147 38.5889 33.5002 38.5827 33.5064Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5369 33.5244V33.5382H38.5782C38.561 33.5287 38.5569 33.5279 38.5369 33.5244Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5048 33.5704C38.4986 33.5766 38.513 33.5759 38.5137 33.5752C38.5199 33.569 38.5055 33.5697 38.5048 33.5704Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2179 33.7359C32.2116 33.7421 32.2261 33.7414 32.2268 33.7408C32.233 33.7345 32.2185 33.7352 32.2179 33.7359Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2886 33.7729C38.281 33.7955 38.2836 33.7929 38.261 33.8005V33.8143C38.2884 33.8026 38.2982 33.8004 38.2886 33.7729Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2822 33.8233C32.2815 33.824 32.2808 33.8385 32.287 33.8323C32.2877 33.8316 32.2884 33.8171 32.2822 33.8233Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2058 33.8418V33.8694C38.2284 33.862 38.226 33.8642 38.2334 33.8418H38.2058Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3095 33.8785C32.3088 33.8792 32.3081 33.8937 32.3143 33.8875C32.315 33.8868 32.3157 33.8723 32.3095 33.8785Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.123 33.9106V33.9382C38.1455 33.9308 38.1432 33.933 38.1506 33.9106H38.123Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1 33.9337C38.0994 33.9344 38.0987 33.9488 38.1049 33.9426C38.1056 33.9419 38.1062 33.9275 38.1 33.9337Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3786 33.9615C32.3779 33.9622 32.3772 33.9767 32.3834 33.9705C32.3841 33.9698 32.3848 33.9553 32.3786 33.9615Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0725 33.9752C38.0718 33.9759 38.0711 33.9903 38.0773 33.9841C38.078 33.9834 38.0787 33.969 38.0725 33.9752Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0036 34.0167C38.0029 34.0174 38.0022 34.0318 38.0084 34.0256C38.0091 34.025 38.0098 34.0105 38.0036 34.0167Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.489 34.0855C32.4883 34.0862 32.4876 34.1007 32.4938 34.0945C32.4945 34.0938 32.4952 34.0793 32.489 34.0855Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5302 34.1265C32.5295 34.1272 32.5288 34.1417 32.535 34.1355C32.5357 34.1348 32.5364 34.1203 32.5302 34.1265Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.659 34.246C32.6528 34.2522 32.6673 34.2516 32.668 34.2509C32.6742 34.2447 32.6597 34.2454 32.659 34.246Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7094 34.2784C32.7087 34.2791 32.708 34.2936 32.7142 34.2874C32.7149 34.2867 32.7156 34.2722 32.7094 34.2784Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7281 34.2875C32.7219 34.2937 32.7364 34.2931 32.7371 34.2924C32.7433 34.2862 32.7288 34.2869 32.7281 34.2875Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.613 34.2827V34.2965H37.6544C37.6372 34.287 37.633 34.2862 37.613 34.2827Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.59 34.3062C37.5893 34.3069 37.5887 34.3214 37.5949 34.3152C37.5955 34.3145 37.5962 34.3 37.59 34.3062Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7646 34.3199C32.7639 34.3206 32.7632 34.3351 32.7694 34.3289C32.7701 34.3282 32.7708 34.3137 32.7646 34.3199Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5396 34.3427C37.5334 34.3489 37.5479 34.3482 37.5486 34.3475C37.5548 34.3413 37.5403 34.342 37.5396 34.3427Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3557 34.4439C37.355 34.4446 37.3543 34.4591 37.3605 34.4529C37.3612 34.4522 37.3619 34.4377 37.3557 34.4439Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0037 34.4804C32.9975 34.4866 33.012 34.4859 33.0127 34.4852C33.0189 34.479 33.0044 34.4797 33.0037 34.4804Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0678 34.5127C33.0671 34.5134 33.0664 34.5279 33.0726 34.5217C33.0733 34.521 33.074 34.5065 33.0678 34.5127Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1829 34.5771C33.1767 34.5833 33.1912 34.5826 33.1919 34.5819C33.1981 34.5757 33.1836 34.5764 33.1829 34.5771Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2197 34.5816C33.219 34.5823 33.2183 34.5968 33.2245 34.5906C33.2252 34.5899 33.2259 34.5754 33.2197 34.5816Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0479 34.5723V34.6136H37.0616C37.0582 34.5936 37.0573 34.5895 37.0479 34.5723Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2796 34.6183C33.2734 34.6245 33.2879 34.6238 33.2886 34.6231C33.2948 34.6169 33.2803 34.6176 33.2796 34.6183Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3072 34.6323C33.301 34.6385 33.3155 34.6378 33.3162 34.6371C33.3224 34.6309 33.3079 34.6316 33.3072 34.6323Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3348 34.6459C33.3286 34.6521 33.3431 34.6515 33.3438 34.6508C33.35 34.6446 33.3355 34.6453 33.3348 34.6459Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9282 34.6505C36.9275 34.6512 36.9268 34.6656 36.933 34.6594C36.9337 34.6587 36.9344 34.6443 36.9282 34.6505Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4312 34.6874C33.425 34.6937 33.4395 34.693 33.4402 34.6923C33.4464 34.6861 33.4319 34.6868 33.4312 34.6874Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4677 34.692C33.467 34.6927 33.4663 34.7071 33.4725 34.7009C33.4732 34.7002 33.4739 34.6858 33.4677 34.692Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5322 34.7104C33.5398 34.733 33.5374 34.7306 33.5598 34.738C33.5522 34.7154 33.5548 34.7179 33.5322 34.7104Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6426 34.7656V34.7794H33.6839C33.6667 34.7699 33.6626 34.7691 33.6426 34.7656Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.739 34.793V34.8068H33.7804C33.7631 34.7973 33.759 34.7964 33.739 34.793Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7896 34.8251C33.7834 34.8313 33.7979 34.8307 33.7986 34.83C33.8048 34.8238 33.7903 34.8245 33.7896 34.8251Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8261 34.8297C33.8254 34.8304 33.8247 34.8448 33.8309 34.8386C33.8316 34.8379 33.8323 34.8235 33.8261 34.8297Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9276 34.8526C33.9214 34.8588 33.9358 34.8581 33.9365 34.8575C33.9427 34.8512 33.9283 34.8519 33.9276 34.8526Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9458 34.8618V34.8756H33.9872C33.9699 34.8661 33.9658 34.8653 33.9458 34.8618Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.024 34.8803C34.0178 34.8865 34.0323 34.8858 34.033 34.8851C34.0392 34.8789 34.0247 34.8796 34.024 34.8803Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0286 34.8896V34.9034H34.0699C34.0527 34.894 34.0486 34.8931 34.0286 34.8896Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0562 34.9033V34.9171H34.0975C34.0803 34.9076 34.0761 34.9068 34.0562 34.9033Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2078 34.9308V34.9446H34.2491C34.2319 34.9351 34.2278 34.9342 34.2078 34.9308Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2673 34.94C34.2666 34.9407 34.2659 34.9552 34.2721 34.949C34.2728 34.9483 34.2735 34.9338 34.2673 34.94Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4421 34.9858V34.9996H34.4835C34.4663 34.9901 34.4621 34.9893 34.4421 34.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4973 34.9858V34.9996H34.5387C34.5214 34.9901 34.5173 34.9893 34.4973 34.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5525 34.9858V35.0134C34.5751 35.006 34.5725 35.0084 34.5801 34.9858H34.5525Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5983 34.9952C34.5976 34.9959 34.597 35.0104 34.6032 35.0042C34.6039 35.0035 34.6045 34.989 34.5983 34.9952Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7335 34.9907C35.7273 34.9969 35.7417 34.9962 35.7424 34.9955C35.7486 34.9893 35.7342 34.99 35.7335 34.9907Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8577 34.9907C35.8515 34.9969 35.866 34.9962 35.8667 34.9955C35.8729 34.9893 35.8584 34.99 35.8577 34.9907Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6307 35.0043C34.6245 35.0105 34.639 35.0099 34.6397 35.0092C34.6459 35.003 34.6314 35.0037 34.6307 35.0043Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6583 35.0043C34.6521 35.0105 34.6666 35.0099 34.6672 35.0092C34.6734 35.003 34.659 35.0037 34.6583 35.0043Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7135 35.018C34.7073 35.0242 34.7217 35.0235 34.7224 35.0228C34.7286 35.0166 34.7141 35.0173 34.7135 35.018Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4854 35.018C35.4792 35.0242 35.4937 35.0235 35.4944 35.0228C35.5006 35.0166 35.4861 35.0173 35.4854 35.018Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5406 35.018C35.5344 35.0242 35.5489 35.0235 35.5496 35.0228C35.5558 35.0166 35.5413 35.0173 35.5406 35.018Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7823 35.0319C34.7761 35.0381 34.7906 35.0375 34.7913 35.0368C34.7975 35.0306 34.783 35.0313 34.7823 35.0319Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8375 35.0317C34.8313 35.0379 34.8458 35.0372 34.8464 35.0365C34.8526 35.0303 34.8382 35.031 34.8375 35.0317Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9063 35.0317C34.9001 35.0379 34.9146 35.0372 34.9153 35.0365C34.9215 35.0303 34.907 35.031 34.9063 35.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9478 35.0317C34.9416 35.0379 34.9561 35.0372 34.9568 35.0365C34.963 35.0303 34.9485 35.031 34.9478 35.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0028 35.0317C34.9966 35.0379 35.011 35.0372 35.0117 35.0365C35.0179 35.0303 35.0035 35.031 35.0028 35.0317Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0719 35.0317C35.0657 35.0379 35.0801 35.0372 35.0808 35.0365C35.087 35.0303 35.0725 35.031 35.0719 35.0317Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3475 35.0317C35.3413 35.0379 35.3558 35.0372 35.3565 35.0365C35.3627 35.0303 35.3482 35.031 35.3475 35.0317Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4166 35.0317C35.4104 35.0379 35.4249 35.0372 35.4255 35.0365C35.4317 35.0303 35.4173 35.031 35.4166 35.0317Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1407 35.0458C35.1345 35.0521 35.149 35.0514 35.1497 35.0507C35.1559 35.0445 35.1414 35.0452 35.1407 35.0458Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1959 35.0458C35.1897 35.0521 35.2042 35.0514 35.2048 35.0507C35.211 35.0445 35.1966 35.0452 35.1959 35.0458Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3062 35.0458C35.3 35.0521 35.3145 35.0514 35.3152 35.0507C35.3214 35.0445 35.3069 35.0452 35.3062 35.0458Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3614 35.0458C35.3552 35.0521 35.3697 35.0514 35.3704 35.0507C35.3766 35.0445 35.3621 35.0452 35.3614 35.0458Z",
    fill: "#DAEBDA"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54297 44.689C3.27995 44.689 3.81771 44.8478 4.15625 45.1655C4.49479 45.4806 4.66406 45.9155 4.66406 46.4702C4.66406 46.7202 4.6263 46.9598 4.55078 47.189C4.47526 47.4155 4.35156 47.6174 4.17969 47.7944C4.01042 47.9715 3.78385 48.1121 3.5 48.2163C3.21615 48.3179 2.86589 48.3687 2.44922 48.3687H1.92969V50.3999H0.71875V44.689H2.54297ZM2.48047 45.6812H1.92969V47.3765H2.32812C2.55469 47.3765 2.7513 47.3465 2.91797 47.2866C3.08464 47.2267 3.21354 47.133 3.30469 47.0054C3.39583 46.8778 3.44141 46.7137 3.44141 46.5132C3.44141 46.2319 3.36328 46.0236 3.20703 45.8882C3.05078 45.7502 2.80859 45.6812 2.48047 45.6812ZM8.26531 50.3999H7.05438V45.6968H5.50359V44.689H9.81609V45.6968H8.26531V50.3999ZM13.4408 45.6147C13.209 45.6147 13.0033 45.6603 12.8236 45.7515C12.6465 45.84 12.4968 45.9689 12.3744 46.1382C12.2546 46.3075 12.1634 46.5119 12.1009 46.7515C12.0384 46.991 12.0072 47.2606 12.0072 47.5601C12.0072 47.9637 12.0567 48.3088 12.1556 48.5952C12.2572 48.8791 12.4134 49.0965 12.6244 49.2476C12.8353 49.396 13.1074 49.4702 13.4408 49.4702C13.6726 49.4702 13.9043 49.4442 14.1361 49.3921C14.3705 49.34 14.6244 49.2658 14.8978 49.1694V50.1851C14.6452 50.2892 14.3965 50.3634 14.1517 50.4077C13.9069 50.4546 13.6322 50.478 13.3275 50.478C12.739 50.478 12.2546 50.3569 11.8744 50.1147C11.4968 49.87 11.2168 49.5288 11.0345 49.0913C10.8522 48.6512 10.7611 48.1382 10.7611 47.5522C10.7611 47.12 10.8197 46.7241 10.9369 46.3647C11.0541 46.0054 11.2259 45.6942 11.4525 45.4312C11.6791 45.1681 11.959 44.965 12.2923 44.8218C12.6257 44.6785 13.0085 44.6069 13.4408 44.6069C13.7246 44.6069 14.0085 44.6434 14.2923 44.7163C14.5788 44.7866 14.8522 44.8843 15.1127 45.0093L14.722 45.9937C14.5085 45.8921 14.2936 45.8035 14.0775 45.728C13.8614 45.6525 13.6491 45.6147 13.4408 45.6147ZM16.4366 44.689H17.5264V47.4468C17.5264 47.5822 17.5238 47.7319 17.5186 47.896C17.516 48.0601 17.5108 48.2215 17.503 48.3804C17.4978 48.5366 17.4926 48.6733 17.4873 48.7905C17.4821 48.9077 17.4769 48.9858 17.4717 49.0249H17.4952L20.1319 44.689H21.5811V50.3999H20.503V47.6577C20.503 47.5119 20.5056 47.353 20.5108 47.1812C20.516 47.0093 20.5225 46.8426 20.5303 46.6812C20.5407 46.5197 20.5498 46.3804 20.5577 46.2632C20.5655 46.1434 20.5707 46.064 20.5733 46.0249H20.542L17.8936 50.3999H16.4366V44.689ZM25.7605 50.3999L24.3855 45.9194H24.3503C24.3555 46.0262 24.3633 46.1877 24.3738 46.4038C24.3868 46.6174 24.3985 46.8452 24.4089 47.0874C24.4193 47.3296 24.4245 47.5483 24.4245 47.7437V50.3999H23.3425V44.689H24.9909L26.3425 49.0562H26.3659L27.7995 44.689H29.448V50.3999H28.3191V47.6968C28.3191 47.5171 28.3217 47.3101 28.3269 47.0757C28.3347 46.8413 28.3438 46.6187 28.3542 46.4077C28.3646 46.1942 28.3724 46.034 28.3777 45.9272H28.3425L26.8698 50.3999H25.7605ZM30.9477 49.8413C30.9477 49.5965 31.0141 49.4246 31.1469 49.3257C31.2823 49.2267 31.4451 49.1772 31.6352 49.1772C31.8201 49.1772 31.9789 49.2267 32.1117 49.3257C32.2471 49.4246 32.3148 49.5965 32.3148 49.8413C32.3148 50.0757 32.2471 50.245 32.1117 50.3491C31.9789 50.4533 31.8201 50.5054 31.6352 50.5054C31.4451 50.5054 31.2823 50.4533 31.1469 50.3491C31.0141 50.245 30.9477 50.0757 30.9477 49.8413ZM38.4669 50.3999H37.0919L35.0216 47.5054V50.3999H33.8106V44.689H35.0216V47.4546L37.0684 44.689H38.3575L36.2755 47.4312L38.4669 50.3999ZM43.0017 50.3999L42.5877 49.0405H40.5056L40.0916 50.3999H38.7869L40.8025 44.6655H42.283L44.3064 50.3999H43.0017ZM42.2986 48.0249L41.8845 46.6968C41.8585 46.6082 41.8233 46.495 41.7791 46.3569C41.7374 46.2163 41.6944 46.0744 41.6502 45.9312C41.6085 45.7853 41.5746 45.659 41.5486 45.5522C41.5226 45.659 41.4861 45.7918 41.4392 45.9507C41.3949 46.1069 41.352 46.2554 41.3103 46.396C41.2686 46.5366 41.2387 46.6369 41.2205 46.6968L40.8103 48.0249H42.2986ZM47.1733 44.689C47.9103 44.689 48.448 44.8478 48.7866 45.1655C49.1251 45.4806 49.2944 45.9155 49.2944 46.4702C49.2944 46.7202 49.2566 46.9598 49.1811 47.189C49.1056 47.4155 48.9819 47.6174 48.81 47.7944C48.6407 47.9715 48.4142 48.1121 48.1303 48.2163C47.8465 48.3179 47.4962 48.3687 47.0795 48.3687H46.56V50.3999H45.3491V44.689H47.1733ZM47.1108 45.6812H46.56V47.3765H46.9584C47.185 47.3765 47.3816 47.3465 47.5483 47.2866C47.7149 47.2267 47.8439 47.133 47.935 47.0054C48.0261 46.8778 48.0717 46.7137 48.0717 46.5132C48.0717 46.2319 47.9936 46.0236 47.8373 45.8882C47.6811 45.7502 47.4389 45.6812 47.1108 45.6812ZM50.6925 50.3999V44.689H51.9034V46.8804H52.38C52.9165 46.8804 53.3566 46.9546 53.7003 47.103C54.0467 47.2515 54.3019 47.4572 54.4659 47.7202C54.6326 47.9806 54.7159 48.2788 54.7159 48.6147C54.7159 49.1799 54.5271 49.6187 54.1495 49.9312C53.7745 50.2437 53.1769 50.3999 52.3566 50.3999H50.6925ZM51.9034 49.4077H52.3097C52.6769 49.4077 52.9659 49.3491 53.1769 49.2319C53.3878 49.1121 53.4933 48.9064 53.4933 48.6147C53.4933 48.4116 53.4412 48.2567 53.337 48.1499C53.2355 48.0431 53.0883 47.9702 52.8956 47.9312C52.7055 47.8921 52.4777 47.8726 52.212 47.8726H51.9034V49.4077ZM59.4109 50.3999H56.1219V44.689H59.4109V45.6812H57.3328V46.9351H59.2664V47.9272H57.3328V49.3999H59.4109V50.3999ZM62.7505 44.689C63.4874 44.689 64.0252 44.8478 64.3638 45.1655C64.7023 45.4806 64.8716 45.9155 64.8716 46.4702C64.8716 46.7202 64.8338 46.9598 64.7583 47.189C64.6828 47.4155 64.5591 47.6174 64.3872 47.7944C64.2179 47.9715 63.9914 48.1121 63.7075 48.2163C63.4236 48.3179 63.0734 48.3687 62.6567 48.3687H62.1372V50.3999H60.9263V44.689H62.7505ZM62.688 45.6812H62.1372V47.3765H62.5356C62.7622 47.3765 62.9588 47.3465 63.1255 47.2866C63.2921 47.2267 63.421 47.133 63.5122 47.0054C63.6033 46.8778 63.6489 46.7137 63.6489 46.5132C63.6489 46.2319 63.5708 46.0236 63.4145 45.8882C63.2583 45.7502 63.0161 45.6812 62.688 45.6812ZM69.7658 50.3999L69.3517 49.0405H67.2697L66.8556 50.3999H65.5509L67.5666 44.6655H69.047L71.0705 50.3999H69.7658ZM69.0627 48.0249L68.6486 46.6968C68.6225 46.6082 68.5874 46.495 68.5431 46.3569C68.5015 46.2163 68.4585 46.0744 68.4142 45.9312C68.3725 45.7853 68.3387 45.659 68.3127 45.5522C68.2866 45.659 68.2502 45.7918 68.2033 45.9507C68.159 46.1069 68.116 46.2554 68.0744 46.396C68.0327 46.5366 68.0028 46.6369 67.9845 46.6968L67.5744 48.0249H69.0627Z",
    fill: "#2196F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_160003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_61_160003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49e67d75ea23a747aa83a280015af393.svg";
export { ForwardRef as ReactComponent };